var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewDragonLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 780,
    viewBox: "0 0 370 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_556_10751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.408 74.1313H164.45L152.5 78.4783L166.195 84.1168L177.408 74.1313Z",
    fill: "#7B5F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.473 102.501L169.927 104.503L146.358 108.802L159.217 129.441L189.473 102.501Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 101.73L146.358 108.802L141.545 89.5238L126.772 101.73Z",
    fill: "#744D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.292 87.592L146.358 108.802L169.927 104.503L162.292 87.592Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.499 78.4783L166.195 84.1168L162.292 87.592L141.544 89.5238L152.499 78.4783Z",
    fill: "#6D5531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.358 108.802L141.544 89.5238L162.292 87.592L146.358 108.802Z",
    fill: "#62383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1978 94.7552L92.0824 93.5574L88.0989 97.3777L64.1978 94.7552Z",
    fill: "#967546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 101.73L105.195 94.4859L92.0826 93.5574L88.0991 97.3777L126.772 101.73Z",
    fill: "#7B5F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1978 94.7552L105.029 80.1377L92.0824 93.5574L64.1978 94.7552Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 101.73L121.461 88.752L105.195 94.4859L126.772 101.73Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.029 80.1377L105.195 94.4859L92.0825 93.5574L105.029 80.1377Z",
    fill: "#D3A96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.461 88.752L105.029 80.1377L105.195 94.4859L121.461 88.752Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.545 89.5238L121.461 88.752L126.772 101.73L141.545 89.5238Z",
    fill: "#8F683F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.029 80.1377L117.145 76.8213L121.461 88.752L105.029 80.1377Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.545 89.5238L129.262 82.4598L121.461 88.752L141.545 89.5238Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.499 78.4783L140.217 80.4668L141.545 89.5238L152.499 78.4783Z",
    fill: "#7B5F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.262 82.4598L140.217 80.4668L141.545 89.5238L129.262 82.4598Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 76.8213L129.262 82.4598L121.461 88.752L117.146 76.8213Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.499 78.4783L137.727 72.3473L129.262 82.4598L140.217 80.4668L152.499 78.4783Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 76.8213L137.727 72.3473L129.262 82.4598L117.146 76.8213Z",
    fill: "#F2C07B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 101.73L107.436 124.691L133.411 116.378L126.772 101.73Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.358 108.802L133.412 116.378L126.772 101.73L146.358 108.802Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.217 129.441L183.603 135.973L194.903 124.691L159.217 129.441Z",
    fill: "#6B3020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.412 116.378L159.217 129.441L146.358 108.802L133.412 116.378Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.773 101.73L101.986 104.651L93.0786 115.971L107.436 113.211V124.691L126.773 101.73Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.603 135.973L166.195 150.062L169.927 132.31L183.603 135.973Z",
    fill: "#915933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87 158.513L159.217 139.789L166.195 150.062L153.87 158.513Z",
    fill: "#835635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.217 129.441V139.789L166.195 150.062L169.927 132.31L159.217 129.441Z",
    fill: "#8B613B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.113 156.856L153.87 158.513L159.218 139.789L146.379 140.369L145.113 156.856Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.218 129.441L145.113 135.973L146.379 140.369L159.218 139.789V129.441Z",
    fill: "#8F683F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.503 142.606L145.113 135.973L146.379 140.369L145.113 156.856L131.503 142.606Z",
    fill: "#A98757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.941 179.06L153.87 158.513L145.113 156.856L138.941 179.06Z",
    fill: "#A98757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.503 142.606L138.889 167.958L145.113 156.856L131.503 142.606Z",
    fill: "#B4905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.461 172.432L138.889 167.958L138.941 179.06L121.461 172.432Z",
    fill: "#E3BD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.113 156.856L138.941 179.06L138.889 167.958L145.113 156.856Z",
    fill: "#BB9965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.503 142.606L130.201 159.839L138.889 167.958L131.503 142.606Z",
    fill: "#BB9965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.984 152.216L131.503 142.606L130.201 159.839L115.984 152.216Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.461 172.432L130.201 159.839L138.889 167.958L121.461 172.432Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.984 152.216L121.461 172.432L130.201 159.839L115.984 152.216Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.283 184.694L138.941 179.06L121.461 172.432L124.283 184.694Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93 181.38L121.461 172.432L124.283 184.694L108.93 181.38Z",
    fill: "#E3B574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.195 164.81L108.929 181.38L121.461 172.432L105.195 164.81Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.984 152.216L105.195 164.81L121.461 172.432L115.984 152.216Z",
    fill: "#967546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.929 181.38H92.0825L105.195 164.81L108.929 181.38Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0537 194.305L92.0825 181.38H108.929L99.0537 194.305Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.854 197.951L92.0824 181.38L99.0535 194.305L86.854 197.951Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.941 179.06L130.201 197.951L124.283 184.694L138.941 179.06Z",
    fill: "#E3B574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93 181.38L117.146 202.922L124.283 184.694L108.93 181.38Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0537 194.305L117.146 202.922L108.93 181.38L99.0537 194.305Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.201 197.95L117.146 202.922L124.283 184.694L130.201 197.95Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 219.05L117.146 202.922L130.201 197.951L127.879 219.05Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0535 194.305L92.0824 205.352L86.854 197.95L99.0535 194.305Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7407 215.294L86.8543 197.951L92.0827 205.352L80.7407 215.294Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7407 241.586V215.294L96.4535 237.609L80.7407 241.586Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0827 205.352L96.4535 237.609L80.7407 215.294L92.0827 205.352Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 202.922L107.436 208.5L99.0537 194.305L117.146 202.922Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0825 205.352L107.436 208.5L99.0537 194.305L92.0825 205.352Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 219.05L113.328 228.44L117.146 202.922L127.879 219.05Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.773 241.586L127.879 219.05L113.328 228.44L126.773 241.586Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4533 237.609L113.328 228.44L92.0825 205.352L96.4533 237.609Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 208.5L99.0537 212.928L92.0825 205.352L107.436 208.5Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 202.922L107.436 208.5L99.0537 212.928L113.328 228.44L117.146 202.922Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4535 237.609L89.8143 263.238L80.7407 241.586L96.4535 237.609Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.506 285.773L89.814 263.238L107.436 269.866L100.506 285.773Z",
    fill: "#D9B47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.283 307.425L100.506 285.773L126.108 289.087L124.283 307.425Z",
    fill: "#CEAB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 269.866L126.108 289.087L100.506 285.773L107.436 269.866Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.814 263.238L113.328 250.423L107.436 269.866L89.814 263.238Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4532 237.609L113.328 250.423L89.814 263.238L96.4532 237.609Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.328 228.44V250.423L96.4531 237.609L113.328 228.44Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.773 241.586L113.328 250.423V228.44L126.773 241.586Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 249.098L126.773 241.586L113.328 250.423L127.879 249.098Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 269.866L126.772 263.238L113.328 250.423L107.436 269.866Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 249.098L126.773 263.238L113.328 250.423L127.879 249.098Z",
    fill: "#F5D096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 261.028L126.772 263.238L127.879 249.098L138.308 261.028Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 274.505V261.028L126.772 263.238L138.308 274.505Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.109 289.087V274.505L113.328 275.931L126.109 289.087Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 263.238L126.108 274.505L107.436 269.866L126.772 263.238Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.328 275.931L107.436 269.866L126.108 274.505L113.328 275.931Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 274.505H126.108L126.772 263.238L138.308 274.505Z",
    fill: "#D9B47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.108 289.087H140.936L126.108 274.505V289.087Z",
    fill: "#D9B47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.283 307.425L140.936 289.087H126.109L124.283 307.425Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 318.914L124.283 307.425L146.405 306.321V318.914Z",
    fill: "#CEAB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.403 324.217L146.405 318.914L172.005 312.617L162.403 324.217Z",
    fill: "#8F683F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.984 329.077L162.403 324.217L172.005 312.617L182.984 329.077Z",
    fill: "#8B613B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 289.087L146.405 306.321L124.283 307.425L140.936 289.087Z",
    fill: "#D9B47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 285.773L140.936 289.087L146.405 306.321V285.773Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 274.505L140.936 289.087L126.108 274.505H138.308Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 285.773L138.308 274.505L140.936 289.087L146.405 285.773Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 318.914L160.411 302.123L146.405 285.773V318.914Z",
    fill: "#B4905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.005 312.617L160.411 302.123L146.405 318.914L172.005 312.617Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.984 329.077L194.935 320.847L172.005 312.617L182.984 329.077Z",
    fill: "#7B492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 241.586L138.308 261.028L127.879 249.098L126.772 241.586Z",
    fill: "#77432B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.935 320.847L208.877 332.391L182.984 329.077L194.935 320.847Z",
    fill: "#77432B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.82 337.181L208.877 332.391L194.935 320.847L224.82 337.181Z",
    fill: "#6F3523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36 318.299L265.089 344.101L267.523 321.159L253.36 318.299Z",
    fill: "#6B3020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.121 332.391L269.958 339.903L267.523 321.159L284.121 332.391Z",
    fill: "#835635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 344.101L269.958 339.903L267.523 321.159L265.089 344.101Z",
    fill: "#77432B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.777 349.183L265.089 344.101L269.958 339.903L284.121 332.391L286.777 349.183Z",
    fill: "#8F683F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.826 355.369L286.777 349.183L284.122 332.391L301.826 355.369Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 344.101L274.605 359.788L284.121 361.555L286.777 349.182L265.089 344.101Z",
    fill: "#865C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 372.16L301.826 355.369L292.974 363.764L305.146 372.16Z",
    fill: "#BB9965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.122 361.555L292.974 363.764L301.826 355.369L286.777 349.182L284.122 361.555Z",
    fill: "#B4905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 372.16L290.54 382.102L307.58 400.44L305.146 372.16Z",
    fill: "#CEAB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.974 363.764L290.54 382.102L305.146 372.16L292.974 363.764Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.122 377.684L292.974 363.764L290.539 382.102L284.122 377.684Z",
    fill: "#BCA375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 359.788L284.122 377.684L292.974 363.764L284.122 361.555L274.605 359.788Z",
    fill: "#A1895F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 370.172V359.788L284.122 377.684L274.605 370.172Z",
    fill: "#947C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58 400.44L290.54 413.254L299.06 391.271L307.58 400.44Z",
    fill: "#F5D096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.54 382.102V413.254L299.06 391.271L290.54 382.102Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 370.172L283.79 397.678L290.54 382.102L284.122 377.684L274.605 370.172Z",
    fill: "#E4CA98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.539 413.254L283.79 397.678L290.539 382.102V413.254Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.974 434.906L285.449 417.894L290.539 413.254L307.58 400.44L292.974 434.906Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.613 454.349L292.974 434.906L274.605 438.662L272.613 454.349Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.65 391.271L279.363 404.417L290.539 413.254L281.65 391.271Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.449 417.894L279.363 404.417L290.539 413.255L285.449 417.894Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.409 427.836L279.363 404.417L285.449 417.894L268.409 427.836Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.974 434.906L277.102 422.765L285.449 417.894L292.974 434.906Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 438.662L277.102 422.765L292.974 434.906L274.605 438.662Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.409 427.836L274.605 438.662L277.102 422.765L268.409 427.836Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.614 454.349L249.155 464.954L258.45 450.372L272.614 454.349Z",
    fill: "#E4CA98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.408 427.836L265.974 441.093L274.605 438.662L268.408 427.836Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.644 442.772L268.409 427.836L265.974 441.093L254.644 442.772Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.45 450.372L265.974 441.093L272.613 454.349L258.45 450.372Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 438.662L272.613 454.349L265.974 441.093L274.605 438.662Z",
    fill: "#F5D096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.644 442.772L258.45 450.372L265.974 441.093L254.644 442.772Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 464.954V448.826L258.45 450.372L249.155 464.954Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.644 442.772L249.155 448.826L258.45 450.372L254.644 442.772Z",
    fill: "#E4CA98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 464.954L219.942 466.501L234.549 459.431L249.155 464.954Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 448.826L234.549 459.43L249.155 464.954V448.826Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.942 466.501L201.131 459.431H234.549L219.942 466.501Z",
    fill: "#CEAB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 448.826L214.41 459.43H234.549L249.155 448.826Z",
    fill: "#F5D096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.113 135.973L133.412 116.378L159.217 129.441L145.113 135.973Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.604 135.973H145.113L133.412 116.378L120.604 135.973Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.503 142.606L120.604 135.973H145.113L131.503 142.606Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 124.691L120.603 135.973L133.411 116.378L107.436 124.691Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.984 152.216L120.604 135.973L131.503 142.606L115.984 152.216Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 124.691L102.705 139.289L120.603 135.973L107.436 124.691Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7407 215.294L79.5532 197.951H86.8543L80.7407 215.294Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1187 179.06L92.0826 181.38L89.0774 190.905L84.1187 179.06Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5532 197.951L84.1187 179.06L89.0775 190.905L86.8543 197.951H79.5532Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2772 174.816L92.0826 181.38L84.1187 179.06L90.8681 163.581L97.2772 174.816Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.983 152.216L102.705 139.289L120.603 135.973L115.983 152.216Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9673 158.513L115.983 152.216L102.705 139.289L93.9673 158.513Z",
    fill: "#C52126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.195 164.81L115.983 152.216L93.9673 158.513L105.195 164.81Z",
    fill: "#771030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2769 174.816L93.9673 158.513L105.195 164.81L97.2769 174.816Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2241 164.206L93.9673 158.513L97.2769 174.816L91.2241 164.206Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 262.292L156.843 274.505H138.308V262.292Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.411 302.123L156.843 274.505H138.308L146.405 285.773L160.411 302.123Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21 279.477H167.636L156.843 274.505L160.411 302.123L177.21 279.477Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.562 298.961L177.21 279.477L160.411 302.123L181.562 298.961Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.498 317.101L181.562 298.961L160.411 302.123L172.005 312.617L184.498 317.101Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.099 279.477H177.21L181.562 298.961L198.099 279.477Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.929 300.004L198.099 279.477H214.81L201.929 300.004Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.562 298.961L201.929 300.004L198.099 279.477L181.562 298.961Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.497 317.101L201.929 300.004L181.562 298.961L184.497 317.101Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.018 315.644L201.929 300.004L184.498 317.101L204.018 315.644Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.619 327.907L204.018 315.644L184.498 317.101L194.935 320.847L207.619 327.907Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.81 279.477L219.336 298.256L201.929 300.004L214.81 279.477Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 280.54L219.336 298.256L233.785 296.599L229.781 280.54Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.811 279.477L229.781 280.54L219.337 298.256L214.811 279.477Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 280.54L233.785 296.599L229.781 280.54H247.537Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 297.571V280.54L233.785 296.599L247.537 297.571Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57 311.474H250.148L247.537 296.599L236.57 311.474Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.785 296.599L236.57 311.474L247.537 296.599H233.785Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.561 304.696L233.785 296.599L236.57 311.474L226.561 304.696Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.336 314.775L236.57 311.474L226.561 304.696L219.336 314.775Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.336 298.256L233.785 296.599L226.561 304.696L219.336 298.256Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.337 314.775L204.018 315.644L219.337 298.256V314.775Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.561 304.696L219.336 314.775V298.256L226.561 304.696Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.929 300.004L204.018 315.644L219.336 298.256L201.929 300.004Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.337 314.775L221.6 327.907L204.018 315.644L219.337 314.775Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.619 327.907H221.6L204.018 315.644L207.619 327.907Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.599 328.608L236.57 311.474L219.336 314.775L221.599 328.608Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.148 311.474L248.408 327.907L236.57 311.474H250.148Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6 328.608L234.568 329.077L248.407 327.907L236.57 311.474L221.6 328.608Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 280.54L265.089 271.503L266.337 285.773L247.537 280.54Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 296.599L266.337 285.773L247.537 280.54V296.599Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.008 278.638L266.337 285.773L265.089 271.503L286.008 278.638Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.572 293.4L286.008 278.638L266.337 285.773L282.572 293.4Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.337 304.696C267.034 304.696 282.572 293.4 282.572 293.4L266.337 285.773V304.696Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.337 304.696L247.537 296.599L266.337 285.773V304.696Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.148 311.474L266.337 304.696L247.537 296.599L250.148 311.474Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.407 327.907L259.264 330.845L250.148 311.474L248.407 327.907Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.523 321.159L266.337 304.696L250.148 311.474L267.523 321.159Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36 318.299L250.148 311.474L267.523 321.159L253.36 318.299Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.79 314.775L267.524 321.159L266.337 304.696L283.79 314.775Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.572 293.4L283.79 314.775L266.337 304.696L282.572 293.4Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.008 278.638L305.146 291.662L282.572 293.4L286.008 278.638Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 271.503L247.537 268.896V280.54L265.089 271.503Z",
    fill: "#F4816B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 280.54L247.537 268.896V280.54H229.781Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 268.896L214.811 279.477L229.781 280.54L247.537 268.896Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 291.662V310.778L282.572 293.4L305.146 291.662Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.789 314.775L305.146 310.778L282.572 293.4L283.789 314.775Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.121 332.391L283.789 314.775L267.523 321.159L284.121 332.391Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.974 330.845L283.79 314.775L284.121 332.391L292.974 330.845Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 310.778L292.974 330.845L283.79 314.775L305.146 310.778Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.082 303.132L305.146 291.662V310.778L319.082 303.132Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.045 318.946L319.082 303.132L305.146 310.778L326.045 318.946Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.856 331.259L305.146 310.778L326.045 332.391L309.856 331.259Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.666 344.101C337.796 342.537 326.046 318.946 326.046 318.946V332.391L338.666 344.101Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 310.778L326.045 318.946V332.391L305.146 310.778Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.856 331.259L292.974 330.845L305.146 310.778L309.856 331.259Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.826 356.473L309.856 331.259L292.974 330.845L301.826 356.473Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.826 356.473L317.342 344.101L309.857 331.259L301.826 356.473Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.827 356.473H301.826L317.342 344.101L324.827 356.473Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.122 332.391L301.826 356.473L292.974 330.845L284.122 332.391Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.827 356.473L326.046 332.391L309.856 331.259L317.342 344.101L324.827 356.473Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.046 332.391L338.666 344.101L324.827 356.473L326.046 332.391Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.976 359.178L338.666 344.101L324.827 356.473L343.976 359.178Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.747 377.684L343.976 359.178L324.827 356.473L331.747 377.684Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86 377.684L324.827 356.473L331.747 377.684H313.86Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.826 356.473L313.86 377.684L324.827 356.473H301.826Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58 400.44L314.123 377.532L301.826 356.473L305.146 372.97L307.58 400.44Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.747 377.684L322.804 396.412L313.86 377.684H331.747Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.975 359.178L350.677 382.987L331.747 377.683L343.975 359.178Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L350.677 382.987L331.747 377.684L352.244 404.417Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.804 396.412L336.316 397.678L331.747 377.684L322.804 396.412Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L336.316 397.678L331.747 377.684L352.244 404.417Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58 400.44L322.804 396.412L313.86 377.684L307.58 400.44Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.316 397.678L329.56 416.827L322.804 396.412L336.316 397.678Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L329.56 416.827L336.316 397.678L352.244 404.417Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.394 418.816L352.244 404.417L329.56 416.827L348.394 418.816Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.951 416.127L329.56 416.827L322.804 396.412L317.951 416.127Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.394 418.816L335.794 438.662L329.56 416.827L348.394 418.816Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.802 432.516L335.794 438.662L348.395 418.816L344.802 432.516Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.752 464.954L344.933 431.876L335.794 438.662L334.752 464.954Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 445.732L335.794 438.662L334.752 464.954L326.394 445.732Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.951 416.127L335.794 438.662L329.56 416.827L317.951 416.127Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58 400.44L317.951 416.127L322.804 396.412L307.58 400.44Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.481 419.55L317.951 416.127L307.58 400.44L299.481 419.55Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.032 444.628L317.951 416.127L299.481 419.55L312.032 444.628Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.794 438.662L312.032 444.628L317.951 416.127L335.794 438.662Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 445.732L335.794 438.662L312.032 444.628L326.394 445.732Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.032 444.628L299.482 419.55L292.974 434.906L312.032 444.628Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.613 454.349L292.974 434.906L293.754 446.572L272.613 454.349Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.032 444.628L293.754 446.572L292.974 434.906L312.032 444.628Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.549 470.705L312.032 444.628L293.754 446.572L306.549 470.705Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 445.732L306.549 470.705L312.032 444.628L326.394 445.732Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.752 464.954L306.549 470.705L326.394 445.732L334.752 464.954Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.557 488.823L334.752 464.954L306.549 470.705L315.557 488.823Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.41 454.893L260.884 472.27L293.754 446.572L271.41 454.893Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.549 470.705L275.028 461.212L293.754 446.572L306.549 470.705Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.558 488.823L292.318 503.16L306.549 470.705L315.558 488.823Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.549 470.705L289.707 479.699L292.318 503.16L306.549 470.705Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.868 486.933L292.318 503.16L289.707 479.699L275.868 486.933Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.028 461.212L289.707 479.699L275.868 486.933L275.028 461.212Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.549 470.705L289.707 479.699L275.028 461.212L306.549 470.705Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.884 472.269L275.868 486.933L275.028 461.212L260.884 472.269Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.318 503.16H263.596L275.868 486.933L292.318 503.16Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.193 519.192L292.318 503.16H263.596L251.193 519.192Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 502.508L251.193 519.192L263.596 503.16L233.437 502.508Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 502.508L253.803 497.555L263.596 503.16L233.437 502.508Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.868 486.933L253.802 497.555L263.595 503.16L275.868 486.933Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.884 472.27L253.802 497.555L275.868 486.933L260.884 472.27Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 478.265L260.884 472.27L253.803 497.555L233.437 478.265Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 502.508V478.265L253.803 497.555L233.437 502.508Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.193 519.192L229.912 521.538L233.437 502.508L251.193 519.192Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.034 512.023L233.437 502.508L229.912 521.538L221.034 512.023Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 498.815L233.437 502.508L221.034 512.023L212.2 498.815Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 521.147L229.912 521.538L221.034 512.023L206.542 521.147Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.209 484.913L233.437 502.508L212.2 498.815L222.209 484.913Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.596 478.265L222.209 484.913L233.437 502.508V478.265H217.596Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 498.815L204.714 485.781L217.596 478.265L212.2 498.815Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 498.815L193.791 491.864L204.714 485.781L212.2 498.815Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 521.147L181.04 515.847L195.227 512.631L206.542 521.147Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.034 512.023L212.199 498.815L206.542 521.147L221.034 512.023Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 498.815L211.977 498.997L195.227 512.631L206.542 521.147L212.2 498.815Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 491.864L195.227 512.631L212.2 498.815L193.791 491.864Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.005 504.637L183.477 499.25L195.227 512.631L172.005 504.637Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 515.846L172.005 504.637L195.227 512.631L181.04 515.846Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 491.864L183.477 499.25L195.227 512.631L193.791 491.864Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.209 484.913L212.2 498.815L217.596 478.265L222.209 484.913Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.237 472.27L217.596 478.265L204.714 485.781L196.237 472.27Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.005 504.637L150.75 500.358L177.036 482.827L172.005 504.637Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 491.864L177.036 482.827L172.005 504.637L183.477 499.25L193.791 491.864Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.175 475.789L193.791 491.864L177.036 482.827L186.175 475.789Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.238 472.27L193.791 491.864L204.714 485.781L196.238 472.27Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.175 475.789L196.237 472.27L193.791 491.864L186.175 475.789Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 475.789L177.036 482.827L150.75 500.358L166.853 475.789Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.619 482.827L166.853 475.789L150.751 500.358L149.619 482.827Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.641 469.272L150.75 500.358L149.619 482.827L126.641 469.272Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.791 466.501L166.852 475.789L149.619 482.827L147.791 466.501Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.608 475.152L147.791 466.501L149.619 482.827L136.608 475.152Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 459.431L147.791 466.501L136.608 475.152L138.13 459.431Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.641 469.272L138.13 459.431L136.608 475.152L126.641 469.272Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5529 197.95L75.7947 194.305L70.4726 201.403L64.2944 227.809L73.0112 221.48L80.7404 241.586V215.294L79.5529 197.95Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1187 179.06L70.8494 181.38L60.0566 215.294L75.7951 194.305L79.5532 197.95L84.1187 179.06Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7407 241.586L83.2038 268.896L90.8682 283.841L89.8143 263.238L80.7407 241.586Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.885 472.27L249.155 464.954L271.411 454.893L260.885 472.27Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 478.265L249.155 464.954L260.884 472.269L233.437 478.265Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.942 466.501L249.155 464.954L233.437 478.265L219.942 466.501Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.942 466.501L233.437 478.265H217.596L219.942 466.501Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.155 454.128L196.238 472.269L186.175 475.789L165.155 454.128Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.036 482.827L165.155 454.128L186.175 475.789L177.036 482.827Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.791 466.501L165.155 454.128L177.036 482.827L166.852 475.789L147.791 466.501Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 459.431L152.23 447.721L147.791 466.501L138.13 459.431Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.155 454.128L152.23 447.721L147.791 466.501L165.155 454.128Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 459.431L120.604 444.628L126.641 469.272L138.13 459.431Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 441.093V459.431L120.604 444.628L138.13 441.093Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 447.721L138.13 441.093V459.431L152.23 447.721Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.155 454.128L152.23 427.745L138.13 441.093L152.23 447.721L165.155 454.128Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.54 426.4L138.13 441.093L120.604 444.628L132.54 426.4Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 417.673L120.603 444.628L132.54 426.4L117.146 417.673Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 409.995L117.146 417.673L132.54 426.4L133.522 409.995Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 427.745L132.54 426.4L138.13 441.093L152.23 427.745Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 409.995L152.23 427.745L132.54 426.4L133.522 409.995Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 402.263L152.23 427.745L133.522 409.995L140.936 402.263Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.641 469.272L104.891 444.628H120.603L126.641 469.272Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.145 417.673L104.891 444.628H120.603L117.145 417.673Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L349.024 438.662L334.752 464.954L344.933 431.876L352.244 404.417Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.568 329.077L247.161 344.432L248.407 327.907L234.568 329.077Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 402.263L115.766 386.3L133.522 409.995L140.936 402.263Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.145 417.673L115.766 386.3L133.522 409.995L117.145 417.673Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.891 444.628L75.7949 433.747H109.838L104.891 444.628Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 417.673L75.7949 433.746H109.838L117.146 417.673Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 386.3L104.891 401.987L117.145 417.673L115.766 386.3Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4531 425.71L117.145 417.673L104.89 401.987L96.4531 425.71Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4531 377.904L115.766 386.3L104.89 401.987L96.4531 377.904Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7949 433.747L104.891 401.987L96.4534 425.71L75.7949 433.747Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4534 377.904L66.3232 382.102L90.8681 391.271L96.4534 377.904Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.891 401.987L90.8682 391.271L96.4535 377.904L104.891 401.987Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7949 433.746L90.8681 391.271L104.891 401.987L75.7949 433.746Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3494 157.672L67.0194 170.533L53.0933 190.905L70.8491 181.38L84.1184 179.06L94.3494 157.672Z",
    fill: "#C52126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 117.485L79.553 129.441L70.8491 144.095L86.8541 137.861L97.277 151.232L102.705 139.289L107.436 124.691V117.485Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7603 160.124L78.3235 148.901L90.868 143.01L97.277 151.232L94.3495 157.672L78.3235 165.214L83.2036 156.856L68.7603 160.124Z",
    fill: "#BC2126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3231 382.102L41.2561 397.678L90.868 391.271L66.3231 382.102Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.795 433.746L62.4937 415.004L90.8682 391.271L75.795 433.746Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0622 394.475L62.4937 415.004L90.8682 391.271L66.0622 394.475Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2561 397.678L62.4935 415.004L66.062 394.475L41.2561 397.678Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7947 433.747L56.5747 459.421L60.0562 438.662L75.7947 433.747Z",
    fill: "#401211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4937 415.004L60.0566 438.662L75.7951 433.747L62.4937 415.004Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2562 397.678L28.3745 415.004L45.0859 418.87L41.2562 397.678Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4935 415.004L45.0858 418.87L41.2561 397.678L62.4935 415.004Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0565 438.662L45.0859 418.87L62.4936 415.004L60.0565 438.662Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.575 459.421L45.0859 418.87L60.0565 438.662L56.575 459.421Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3745 415.004L18.9744 435.514L45.0859 418.87L28.3745 415.004Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6413 447.721L45.0859 418.87L18.9744 435.514L34.6413 447.721Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.575 459.421L34.6414 447.721L45.086 418.87L56.575 459.421Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9744 435.514V461.212L34.6413 447.721L18.9744 435.514Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5749 459.421L18.9744 461.212L34.6413 447.721L56.5749 459.421Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7596 483.826L18.9744 461.212L37.7746 460.316L21.7596 483.826Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5749 459.421L51.8749 474.073L37.7747 460.317L56.5749 459.421Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8749 474.072L36.7302 484.912L37.7747 460.316L51.8749 474.072Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7595 483.826L36.7301 484.912L37.7746 460.316L21.7595 483.826Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.767 505.419L21.7595 483.826L36.7301 484.912L29.767 505.419Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8749 474.072L62.4936 495.046L36.7302 484.912L51.8749 474.072Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7302 484.913L49.6119 507.331L62.4936 495.046L36.7302 484.913Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7671 505.419L49.6118 507.331L36.7302 484.913L29.7671 505.419Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6118 533.746L29.7671 505.419L49.6118 507.331V533.746Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4935 495.046L75.7948 515.846L49.6118 507.331L62.4935 495.046Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6118 533.746L66.3232 552.168L62.4935 521.147L49.6118 533.746Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6118 507.331L62.4935 521.147L49.6118 533.746V507.331Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7948 515.846L62.4935 521.147L49.6118 507.331L75.7948 515.846Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3232 552.168L85.4717 567.113L81.3883 538.612L66.3232 552.168Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4937 521.147L81.3884 538.612L66.3233 552.168L62.4937 521.147Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.795 515.846L81.3884 538.613L62.4937 521.147L75.795 515.846Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8164 534.702L75.7949 515.846L81.3883 538.613L92.8164 534.702Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4717 567.114L106.799 579.974L97.8794 559.119L85.4717 567.114Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3882 538.612L97.8793 559.119L85.4716 567.113L81.3882 538.612Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8162 534.702L97.8793 559.119L81.3882 538.613L92.8162 534.702Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L97.8794 559.119L92.8164 534.702L115.766 550.343Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.799 579.974L128.351 586.925L119.242 569.547L106.799 579.974Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8794 559.119L119.243 569.547L106.799 579.974L97.8794 559.119Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L119.243 569.547L97.8794 559.119L115.766 550.343Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.351 586.925L147.968 588.402L133.522 574.413L128.351 586.925Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.243 569.547L133.522 574.413L128.351 586.925L119.243 569.547Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L133.522 574.413L119.242 569.547L115.766 550.343Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.968 588.402H172.005L162.413 576.15L147.968 588.402Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 574.413L162.414 576.15L147.968 588.402L133.522 574.413Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.791 567.114L162.414 576.15L133.522 574.413L147.791 567.114Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L147.791 567.113L133.522 574.413L115.766 550.343Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 552.863L147.791 567.113L142.2 555.557L166.853 552.863Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L142.199 555.557L147.791 567.113L115.766 550.343Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.413 576.15L166.852 552.863L147.791 567.113L162.413 576.15Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.005 588.402L193.791 594.659L177.036 582.581L172.005 588.402Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 576.15L177.036 582.581L172.005 588.402L162.414 576.15Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 552.863L177.036 582.58L162.414 576.15L166.853 552.863Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 594.659L203.123 608.127L201.132 584.318L193.791 594.659Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.036 582.581L201.132 584.318L193.791 594.659L177.036 582.581Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.596 478.265L219.942 466.501L196.237 472.269L217.596 478.265Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.131 459.431L196.237 472.269L219.942 466.501L201.131 459.431Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.155 454.128L201.131 459.431L196.238 472.269L165.155 454.128Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 552.863L189.084 558.077L177.036 582.58L166.853 552.863Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.132 584.318L189.084 558.077L177.036 582.581L201.132 584.318Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.227 582.581L201.131 584.318L189.083 558.077L218.227 582.581Z",
    fill: "#F26E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.123 608.127L211.155 596.223L201.131 584.318L203.123 608.127Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.227 582.581L211.155 596.223L201.131 584.318L218.227 582.581Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5751 459.421L62.4937 495.046L51.875 474.073L56.5751 459.421Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.227 582.581L229.912 603.956L211.155 596.223L218.227 582.581Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.123 608.127L208.228 627.591L211.155 596.223L203.123 608.127Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 603.956V625.853L221.034 616.816L229.912 603.956Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.204 606.737L229.912 603.956L211.155 596.223L217.204 606.737Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.229 627.591L217.204 606.737L211.155 596.223L208.229 627.591Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.034 616.816L217.204 606.737L229.912 603.956L221.034 616.816Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.09 627.591L221.034 616.816L217.204 606.737L208.09 627.591Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 625.853L208.09 627.591L221.034 616.816L229.912 625.853Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.283 307.425H108.1L121.461 320.041L124.283 307.425Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 318.914L127.879 313.733L121.461 320.041L124.283 307.425L146.405 318.914Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.099 307.425L107.436 324.217L121.461 320.041L108.099 307.425Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.747 336.368L120.05 331.259L107.436 324.217L112.747 336.368Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.872 320.812L120.05 331.259L107.436 324.217L118.872 320.812Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.619 327.907L224.82 337.181L221.599 327.907H207.619Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.161 344.432L265.089 344.101L259.264 330.845L247.161 344.432Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.408 327.907L259.264 330.845L247.161 344.432L248.408 327.907Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.82 337.181L247.537 352.828H227.953L224.82 337.181Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.568 329.077L224.82 337.181L221.6 327.907L234.568 329.077Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16 344.432L224.82 337.181L234.568 329.077L247.16 344.432Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 352.828L247.16 344.432L224.82 337.181L247.537 352.828Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 344.101L247.537 352.828L247.161 344.432L265.089 344.101Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 370.172L247.537 352.828L265.089 344.101L274.605 370.172Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 359.788V370.172L265.089 344.101L274.605 359.788Z",
    fill: "#6F3523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.974 377.684L274.605 370.172L265.089 363.764L265.974 377.684Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.953 352.828L208.877 359.178L229.781 361.555L227.953 352.828Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 352.828L229.781 361.555L227.954 352.828H247.537Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 363.764L241.488 368.736L265.974 377.684L265.089 363.764Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 352.828L241.488 368.736L265.089 363.764L247.537 352.828Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 361.555L241.488 368.736L247.537 352.828L229.781 361.555Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.174 372.933L265.974 377.684L241.488 368.736L231.174 372.933Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 361.555L231.174 372.933L241.488 368.736L229.781 361.555Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.877 359.178H187.655L201.929 367.128L208.877 359.178Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 361.555L219.336 372.933H231.174L229.781 361.555Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 221.48L136.523 234.139H126.641L127.879 221.48Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 241.586L126.641 234.139H131.612L148.228 249.098L136.656 246.005L136.97 249.098L138.308 262.292L126.772 241.586Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.843 274.505L138.308 262.292L137.104 250.423L145.113 258.121L156.843 274.505Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21 279.477L165.264 270.328L167.636 279.477H177.21Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.843 274.505L165.264 270.328L167.636 279.477L156.843 274.505Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.379 259.89L165.264 270.328L156.843 274.505L146.379 259.89Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 268.896L220.381 269.866L214.811 279.477L247.537 268.896Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.099 279.477L220.381 269.866L214.81 279.477H198.099Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21 279.477L220.381 269.866L198.099 279.477H177.21Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.264 270.328L206.758 272.899L177.21 279.477L165.264 270.328Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.104 250.423L147.552 256.168L177.21 263.433L167.636 265.268L165.264 270.328L146.379 259.89L137.104 250.423Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.758 272.899L232.313 257.6H246.117L236.57 263.238L247.537 268.896L220.381 269.866L206.758 272.899Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.264 270.328L193.921 265.944L203.328 262.03L214.811 260.145L206.455 268.399L206.758 272.899L165.264 270.328Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.083 303.132L342.932 331.524L326.046 318.946L319.083 303.132Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.666 344.101L342.932 331.524L326.046 318.946L338.666 344.101Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.678 382.987L356.161 361.555L343.976 359.178L350.678 382.987Z",
    fill: "#F69480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.666 344.101L352.244 351.639L342.932 331.524L338.666 344.101Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.161 361.555L352.244 351.639L343.976 359.178L356.161 361.555Z",
    fill: "#F4816B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.666 344.101L343.975 359.178L352.244 351.639L338.666 344.101Z",
    fill: "#F26E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.161 361.555L359.469 382.987H350.678L356.161 361.555Z",
    fill: "#F8A795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L359.469 382.987H350.678L352.244 404.417Z",
    fill: "#F69480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L357.206 416.127L349.024 438.662L352.244 404.417Z",
    fill: "#F26E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.468 382.987L357.205 416.127L352.244 404.417L359.468 382.987Z",
    fill: "#F4816B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.395 439.845L347.174 467.33L335.25 486.447L338.035 475.813L334.752 464.954L348.395 439.845Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.558 488.823L296.515 507.505L292.318 503.16L315.558 488.823Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.193 519.192H275.026L292.318 503.16L251.193 519.192Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.515 507.505L275.025 519.192L292.318 503.16L296.515 507.505Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 515.846L172.005 504.637L150.75 500.358L181.04 515.846Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.026 519.192L249.155 527.229L251.193 519.192H275.026Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 521.538L249.155 527.229L251.193 519.192L229.912 521.538Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 530.445L249.155 527.23L229.912 521.538L206.542 530.445Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 521.147V530.445L229.912 521.538L206.542 521.147Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.557 488.823L290.788 529.402L272.613 534.615L284.093 525.057L283.184 514.755L296.514 507.505L315.557 488.823Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.868 518.734L257.46 536.657L233.437 541.219L247.854 531.367L249.155 527.229L275.868 518.734Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 530.445L182.389 524.362L206.542 521.147V530.445Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 515.846L182.389 524.362L206.542 521.147L181.04 515.846Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.75 500.358L182.389 524.362L181.04 515.846L150.75 500.358Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.131 459.431L171.707 442.197L165.155 454.128L201.131 459.431Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 427.745L171.707 442.197L165.155 454.128L152.23 427.745Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.929 367.128L229.781 361.555L208.877 359.178L201.929 367.128Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.336 372.933L201.929 367.128L229.781 361.555L219.336 372.933Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.655 359.178L170.986 363.153L201.929 367.128L187.655 359.178Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.336 372.933L186.458 370.724L201.929 367.128L219.336 372.933Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.986 363.153L201.929 367.128L186.458 370.724L170.986 363.153Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.903 372.098L193.791 380.641L186.458 370.724L206.903 372.098Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 402.263L171.707 442.197L152.23 427.745L140.936 402.263Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.458 370.724L179.386 386.3L193.791 380.641L186.458 370.724Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.386 386.3L177.036 391.271L186.458 405.837L183.143 394.475L186.011 389.946L179.386 386.3Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 380.641L186.011 389.946L179.386 386.3L193.791 380.641Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.401 375.682L198.525 381.135L207.947 395.7L204.633 384.338L206.903 379.107L201.401 375.682Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.337 372.933L206.903 379.107L201.401 375.682L206.903 372.098L219.337 372.933Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.458 370.724L169.464 380.641L175.665 370.724H186.458Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.986 363.153L186.458 370.724H175.665L170.986 363.153Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.464 380.641L162.413 378.512L157.679 386.3L165.264 399.557L165.155 387.048L169.464 380.641Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.665 370.724L162.414 378.512L169.464 380.641L175.665 370.724Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.987 363.153L162.414 378.512L175.665 370.724L170.987 363.153Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.747 336.368L118.285 341.582L133.933 343.103L121.461 337.639L120.05 331.259L112.747 336.368Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 313.733L126.772 321.786L132.385 336.17L133.897 321.341L146.405 318.914L127.879 313.733Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 268.896L284.833 267.393L304.766 274.483L289.359 274.021L286.008 278.638L265.089 271.503L247.537 268.896Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.123 281.796L286.008 278.638L305.145 291.662L319.082 303.132V293.4L332.356 298.256L314.123 281.796Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.455 306.95L319.083 303.132L342.932 331.524L341.995 319.69L359.468 330.845L345.455 306.95Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.161 361.555L352.244 351.639L342.932 331.524L366.605 356.473L370 382.987L360.6 365.26L359.468 382.987L356.161 361.555Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 402.263L110.165 369.452L87.085 362.307L97.7998 370.938L96.4535 377.904L115.766 386.3L140.936 402.263Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5522 363.868L96.4534 377.904L66.3233 382.102L67.9257 375.682L62.8125 372.67L48.0981 369.45L68.5522 363.868Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5762 399.557L41.2562 375.682L66.3233 382.102L41.2562 397.678L36.7303 391.05L11.5762 399.557Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9743 461.212L13.0556 475.789V497.555L4.17773 463.581L18.9743 435.514V461.212Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2562 397.678L11.2572 412.509L0 439.145L11.5761 430.377L18.9744 435.514L28.3745 415.004L41.2562 397.678Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.252 647.055L208.09 627.591L217.204 637.323L199.252 647.055Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 625.853L217.204 637.323L208.09 627.591L229.912 625.853Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.204 654.876L229.912 625.853L217.204 637.323V654.876Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.252 647.055L183.616 659.047H201.131L199.252 647.055Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.084 673.645L183.616 659.047H201.131L189.084 673.645Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 686.157L189.083 673.645L206.542 668.952L189.352 686.157Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.131 659.047L206.542 668.952L189.083 673.645L201.131 659.047Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.204 637.323L199.252 647.055L201.131 659.047L217.204 637.323Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.204 654.876L201.131 659.047L217.204 637.323V654.876Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 668.952L217.204 654.876L201.131 659.047L206.542 668.952Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.599 666.346L179.473 677.555L162.414 668.952L174.599 666.346Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.473 688.069V677.555H169.725L179.473 688.069Z",
    fill: "#210D0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 668.952L169.725 677.555H179.473L162.414 668.952Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 686.157L169.725 677.555L179.473 688.069L162.414 686.157Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 668.952V686.157L169.725 677.555L162.414 668.952Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.895 651.226L174.599 666.346L183.616 659.047L165.895 651.226Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.084 673.645L174.599 666.346L183.616 659.047L189.084 673.645Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.473 677.555L189.084 673.645L174.599 666.346L179.473 677.555Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.473 688.069L189.084 673.645L179.473 677.555V688.069Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 686.157L179.473 688.069L189.084 673.645L189.352 686.157Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.616 659.047L174.755 643.232L174.596 655.066L183.616 659.047Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.895 651.226L174.755 643.232L174.596 655.066L165.895 651.226Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 625.853L174.756 643.232L169.69 647.802L162.414 625.853Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.895 651.226L153.013 637.323L169.69 647.802L165.895 651.226Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.132 637.323H153.014L149.619 627.591L140.132 637.323Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 645.665L140.132 637.323L131.778 632.457L133.522 645.665Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.955 656.092L133.522 645.665L126.382 653.051L135.955 656.092Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.658 666.346L135.955 656.092L133.522 666.346H144.658Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 668.952L144.658 666.346L153.013 675.904L162.414 668.952Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 686.157V701.624L179.473 688.069L189.352 686.157Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.036 709.966L179.473 688.069L181.841 706.711L177.036 709.966Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.413 686.157L153.013 675.904L162.413 668.952V686.157Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.658 685.115L162.414 686.157L153.013 675.904L144.658 685.115Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.619 627.591L131.778 632.457L140.132 637.323L149.619 627.591Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.169 635.155L153.013 637.323L169.69 647.802L161.169 635.155Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.619 627.591L162.414 625.853L153.014 637.323L149.619 627.591Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.573 619.597L162.414 625.853L149.619 627.591L146.573 619.597Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.778 632.457L146.572 619.597L149.619 627.591L131.778 632.457Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.035 622.204L146.572 619.597L131.778 632.457L130.035 622.204Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.413 625.853L153.013 637.323L161.169 635.155L169.69 647.802L162.413 625.853Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.382 653.051L133.522 666.346L135.955 656.092L126.382 653.051Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.778 632.457L126.382 653.051L133.522 645.665L131.778 632.457Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.035 622.204L119.243 632.457H131.779L130.035 622.204Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 645.665L119.242 632.457L123.768 640.365L115.766 645.665Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.779 632.457H119.243L123.769 640.365L131.779 632.457Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 645.665V658.004L123.768 640.365L115.766 645.665Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.382 653.051L123.769 640.365L131.778 632.457L126.382 653.051Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 658.004L126.382 653.051L123.768 640.365L115.766 658.004Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.768 669.821L115.766 658.004L126.382 653.051L123.768 669.821Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 666.346L123.769 669.821L126.382 653.051L133.522 666.346Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.658 685.115L132.82 679.032L144.658 674.861V685.115Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.013 675.904L144.658 666.346V674.861V685.115L153.013 675.904Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 666.346L144.658 674.861V666.346H133.522Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82 679.032L133.522 666.346L144.658 674.861L132.82 679.032Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.769 669.821L132.821 679.032L133.522 666.346L123.769 669.821Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.572 619.597L138.739 612.298L130.035 612.993L135.955 616.816L130.035 622.204L146.572 619.597Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.035 622.204L121.225 619.333L114.308 624.652L121.359 624.636L119.337 632.374L130.035 622.204Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.243 632.457L110.974 633.504L108.561 639.656L113.135 636.897L115.742 645.745L119.243 632.457Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 645.665L108.561 650.424L108.885 657.022L111.924 652.635L115.766 658.004V645.665Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.968 588.402L108.561 589.402L106.799 579.974L128.351 586.925L147.968 588.402Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4717 567.114L108.561 589.402L106.799 579.974L85.4717 567.114Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3232 552.168L74.4178 572.762L85.4717 567.114L66.3232 552.168Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.561 589.402L74.418 572.762L85.4718 567.114L108.561 589.402Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9743 461.212L13.0557 475.789L29.767 505.419L21.7595 483.826L18.9743 461.212Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4178 572.762L45.6082 546.911L66.3233 552.168L74.4178 572.762Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6119 533.746L45.6082 546.911L66.3233 552.168L49.6119 533.746Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7671 505.419L45.6081 546.911L49.6118 533.746L29.7671 505.419Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 475.789L26.8077 519.192L29.767 505.419L13.0557 475.789Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7672 505.419L26.8079 519.192L45.6081 546.911L29.7672 505.419Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.093 104.503L179.827 126.698L194.903 124.691L196.093 104.503Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.473 102.501L196.093 104.503L179.827 126.698L189.473 102.501Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.473 102.501L159.217 129.441L179.827 126.698L189.473 102.501Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.292 87.592L169.927 104.503L175.736 92.9774L162.292 87.592Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.282 307.425L112.747 301.22L98.6386 290.272L90.8679 283.841L89.814 263.238L100.506 285.773L124.282 307.425Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0114 221.48L68.7603 241.586L73.5318 261.028L75.2929 246.005L82.4635 260.69L80.7405 241.586L73.0114 221.48Z",
    fill: "#C52126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.488 325.907L353.115 342.255L342.932 331.524L342.488 325.907Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.636 265.268L180.963 262.714L195.931 261.028L190.428 263.359L193.921 265.944L165.264 270.328L167.636 265.268Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.656 246.005L142.356 247.528L147.552 256.168L137.104 250.423L136.656 246.005Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.081 264.533L259.278 257.6L274.08 261.028L259.278 263.238L263.321 266.265L262.216 268.304L247.537 268.896L239.081 264.533Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.777 349.182L284.122 361.555L292.974 363.764L286.777 349.182Z",
    fill: "#967546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.589 382.102L279.363 404.417L281.65 391.271L278.589 382.102Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.455 268.399L208.877 266.006L221.404 264.131L206.758 272.899L206.455 268.399Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.036 709.966L181.841 706.711L174.755 724.04L177.036 709.966Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.752 464.954L329.56 496.382L315.558 514.239L320.651 495.046L313.327 492.478L315.558 488.823L334.752 464.954Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.75 500.358L165.895 516.889L182.389 524.362L150.75 500.358Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 475.789L165.155 454.128L177.036 482.827L166.853 475.789Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7999 370.938L89.5865 370.504L81.6602 370.724L96.4535 377.904L97.7999 370.938Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9257 375.682L53.6592 378.859L66.3233 382.102L67.9257 375.682Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7301 391.05L26.604 406.619L41.2561 397.678L36.7301 391.05Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5762 430.377V449.548L18.9744 435.514L11.5762 430.377Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7947 433.747L62.7032 462.966L62.4933 495.046L56.5747 459.421L75.7947 433.747Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6034 478.265L75.795 515.846L62.4937 495.046L62.6034 478.265Z",
    fill: "#401211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6035 478.265L66.512 489.4L74.7381 489.243L62.6035 478.265Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8541 498.922L66.5117 489.4L74.7378 489.243L69.8541 498.922Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3251 503.823L74.7377 489.243L69.854 498.922L77.3251 503.823Z",
    fill: "#401211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1955 503.823L75.7949 515.847L88.0677 512.61L81.1369 507.008L77.1955 503.823Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0675 503.051L77.1953 503.823L88.0675 512.61L96.1224 505.702L88.0675 503.051Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1228 505.702L105.418 517.259L88.0679 512.61L96.1228 505.702Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0676 512.61L81.0132 518.761L89.1707 522.701L88.0676 512.61Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3086 517.396L88.0679 512.61L89.171 522.701L96.6318 522.342L93.3086 517.396Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6317 522.342L96.7876 532.767L89.1709 522.701L96.6317 522.342Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7949 515.839L81.0133 518.761L88.0677 512.61L75.7949 515.839Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7948 515.847L69.854 498.922L77.3251 503.823L75.7948 515.847Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7036 462.966L74.7381 489.243L62.6035 478.265L62.7036 462.966Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1708 522.701L89.6338 531.367L75.7949 515.846L89.1708 522.701Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5912 469.272L62.7031 462.965L67.9254 450.814L65.5912 469.272Z",
    fill: "#401211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2686 445.732L89.1708 438.749L75.7948 433.747L70.2686 445.732Z",
    fill: "#210D0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4307 489.596L18.9744 520.539L32.0301 546.911L28.3745 527.23L31.5373 526.165L26.8078 519.192L17.4307 489.596Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0657 531.367L42.5618 552.863L55.9657 565.723L49.6119 552.863L55.7907 556.048L45.6082 546.911L35.0657 531.367Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 658.004L113.921 661.804L117.575 668.952L116.863 663.478L118.414 661.914L115.766 658.004Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.087 665.651L119.243 669.451L122.897 676.599L122.185 671.125L123.769 669.821L121.087 665.651Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.083 558.077H203.255L212.925 564.847L203.396 565.251L206.549 572.762L189.083 558.077Z",
    fill: "#F4816B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.549 572.762L218.046 571.683L226.059 582.516L217.866 578.857L218.227 582.58L206.549 572.762Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.249 582.581L228.883 589.399L233.221 601.781L228.201 596.223L229.912 603.956L218.249 582.581Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 603.956L236.479 612.906L235.917 624.507L233.828 616.556L229.912 625.853V603.956Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 625.853L231.891 632.073L230.401 640.713L229.358 635.183L224.759 637.623L229.912 625.853Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36 636.8L227.073 642.39L222.669 651.832L222.745 644.852L220.416 642.935L224.36 636.8Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.108 694.428L181.841 706.711L189.352 701.624L184.108 694.428Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 701.624L187.97 717.143L181.841 706.711L189.352 701.624Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.597 725.397L181.841 706.711L187.97 717.143L185.597 725.397Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.755 724.04L173.699 735.461L179.439 725.849L174.755 724.04Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.841 706.711L179.439 725.85L174.755 724.04L181.841 706.711Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.596 725.397L179.438 725.85L181.841 706.711L185.596 725.397Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.596 725.397L179.439 725.849L178.295 733.862L185.596 725.397Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.596 725.397L183.346 740.854L178.295 733.862L185.596 725.397Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.439 725.849L178.295 733.862L173.699 735.461L179.439 725.849Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.295 733.862L173.699 735.461L174.755 748.853L178.295 733.862Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.346 740.854L178.295 733.862L179.439 744.127L186.381 751.277L183.346 740.854Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.755 748.853L178.295 733.862L179.439 744.127L174.755 748.853Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.161 762.79L179.439 744.127L174.755 748.853L181.161 762.79Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.381 751.277L179.438 744.127L180.245 752.87L186.381 751.277Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33 761.457L186.381 751.277L180.246 752.87L192.33 761.457Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.97 764.972L180.246 752.87L192.33 761.457L187.97 764.972Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.161 762.79L180.246 752.87L187.97 764.972L181.161 762.79Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.301 775.031L181.161 762.79L187.97 764.972L193.301 775.031Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33 761.457L200.828 768.911L187.97 764.972L192.33 761.457Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.186 772.244L200.828 768.911L187.97 764.972L197.186 772.244Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.301 775.031L197.186 772.244L187.97 764.972L193.301 775.031Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.689 780L193.301 775.031L197.185 772.244L209.689 780Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.827 768.911L200.555 769.16L197.186 772.244L211.874 770.002L200.827 768.911Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.689 774.425L211.874 770.002L197.186 772.244L209.689 774.425Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.679 775.031L209.689 774.425L197.186 772.244L201.679 775.031Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.689 780L223.164 778.909L209.689 774.425V780Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.679 775.031L209.689 774.425V780L201.679 775.031Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.473 688.069L184.108 694.428L181.841 706.711L179.473 688.069Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.733 769.778L226.933 767.019L223.695 773.938L221.733 769.778Z",
    fill: "#BD2E28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.695 773.938L226.785 775.677L223.165 778.909L223.695 773.938Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.695 773.938L227.901 769.324L226.785 775.677L223.695 773.938Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.695 773.938L226.933 767.019L227.901 769.324L223.695 773.938Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.933 767.019L230.795 766.304L227.901 769.324L226.933 767.019Z",
    fill: "#D42E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.933 767.019L229.769 764.481L230.795 766.304L226.933 767.019Z",
    fill: "#C32E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.768 764.481L227.463 762.792L228.049 766.042L229.768 764.481Z",
    fill: "#63202A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.463 762.792C227.463 762.792 226.202 759.423 226.268 759.332C226.334 759.24 229.844 760.703 229.844 760.703L227.463 762.792Z",
    fill: "#65222B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.268 759.332L227.711 755.032L229.844 760.703L226.268 759.332Z",
    fill: "#721614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.844 760.703L229.768 764.481L227.463 762.792L229.844 760.703Z",
    fill: "#721614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.769 764.481L234.176 750.878L229.981 753.727L229.769 764.481Z",
    fill: "#D22E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.769 764.481L231.744 763.571L230.795 766.304L229.769 764.481Z",
    fill: "#D22E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.901 769.324L231.003 770.129L226.785 775.677L227.901 769.324Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.901 769.324L230.795 766.304L231.003 770.129L227.901 769.324Z",
    fill: "#C72A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.002 770.129L235.352 763.148L230.794 766.304L231.002 770.129Z",
    fill: "#E02B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.794 766.304L231.744 763.571L235.352 763.148L230.794 766.304Z",
    fill: "#C32E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.744 763.571L234.176 750.878L229.769 764.481L231.744 763.571Z",
    fill: "#C32E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.744 763.571L235.352 763.148L233.243 755.586L231.744 763.571Z",
    fill: "#CA312A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.352 763.148L239.167 759.503L233.243 755.586L235.352 763.148Z",
    fill: "#B72D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.352 763.148L240.248 765.283L239.167 759.503L235.352 763.148Z",
    fill: "#DD2F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.248 765.283L231.002 770.129L235.351 763.148L240.248 765.283Z",
    fill: "#B7272E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.002 770.129C231.002 770.129 234.025 772.538 234.161 772.461C234.296 772.384 234.519 768.286 234.519 768.286L231.002 770.129Z",
    fill: "#662625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.519 768.286L236.708 773.082L234.161 772.461L234.519 768.286Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.519 768.286L237.906 770.723L236.707 773.082L234.519 768.286Z",
    fill: "#781514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.906 770.723L242.916 773.763L236.708 773.082L237.906 770.723Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.906 770.723L240.248 765.283L234.519 768.286L237.906 770.723Z",
    fill: "#A62E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.906 770.723L244.678 770.687L240.248 765.283L237.906 770.723Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.906 770.723L240.8 772.479L244.678 770.687L237.906 770.723Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.248 765.283L244.75 760.872L239.167 759.503L240.248 765.283Z",
    fill: "#A53027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.248 765.283L244.679 770.687L246.209 764.508L240.248 765.283Z",
    fill: "#761915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75 760.872L248.371 755.415L239.167 759.503L244.75 760.872Z",
    fill: "#E9282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.167 759.503L245.494 747.928L248.371 755.415L239.167 759.503Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75 760.872L248.724 758.546L248.371 755.415L244.75 760.872Z",
    fill: "#95312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75 760.872L240.248 765.283L246.209 764.508L244.75 760.872Z",
    fill: "#78211F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.209 764.508C246.209 764.508 251.68 771.871 251.476 771.755C251.271 771.64 244.679 770.687 244.679 770.687L246.209 764.508Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.209 764.508L248.724 758.546L244.75 760.872L246.209 764.508Z",
    fill: "#80171B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.209 764.508L251.076 765.274L248.724 758.546L246.209 764.508Z",
    fill: "#7D1C17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.209 764.508L251.076 765.274L251.476 771.755L246.209 764.508Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.475 771.755L256.777 767.826L251.075 765.274L251.475 771.755Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.076 765.274L251.439 758.994L248.724 758.546L251.076 765.274Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.075 765.274L255.12 763.963L251.438 758.994L251.075 765.274Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.12 763.963L256.358 758.302L251.438 758.994L255.12 763.963Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.121 763.963L261.291 760.581L256.358 758.302L255.121 763.963Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.438 758.994L253.275 754.863L256.358 758.302L251.438 758.994Z",
    fill: "#781219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.358 758.302L256.452 754.867L253.275 754.863L256.358 758.302Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.358 758.302L260.047 757.35L256.452 754.867L256.358 758.302Z",
    fill: "#5A0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.439 758.994L248.371 755.415L248.724 758.546L251.439 758.994Z",
    fill: "#5A0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.371 755.415L253.276 754.863L251.439 758.994L248.371 755.415Z",
    fill: "#781219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.371 755.415L245.495 747.928L252.614 752.755L248.371 755.415Z",
    fill: "#EE333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.614 752.755L262.715 752.973L258.548 749.911L252.614 752.755Z",
    fill: "#E02D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.614 752.755L245.495 747.928L255.236 747.945L252.614 752.755Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.614 752.755L258.548 749.911L255.236 747.945L252.614 752.755Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.548 749.911L262.855 747.488L255.235 747.945L258.548 749.911Z",
    fill: "#E9282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.548 749.911L262.715 752.973L262.855 747.488L258.548 749.911Z",
    fill: "#EE333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.715 752.973L272.686 756.796L262.855 747.488L262.715 752.973Z",
    fill: "#E9282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.495 747.928L254.93 745.578L255.236 747.945L245.495 747.928Z",
    fill: "#B72D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.495 747.928L250.426 743.315L254.93 745.578L245.495 747.928Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.93 745.578L260.75 742.582L250.425 743.315L254.93 745.578Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.495 747.928L245.862 743.748L250.426 743.315L245.495 747.928Z",
    fill: "#DD2F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.167 759.503C239.167 759.503 236.148 757.507 236.091 757.469C236.033 757.431 245.495 747.928 245.495 747.928L239.167 759.503Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09 757.469L236.955 753.134L245.494 747.928L236.09 757.469Z",
    fill: "#E9282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.955 753.134L241.421 745.096L245.494 747.928L236.955 753.134Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.421 745.096L245.862 743.748L245.495 747.928L241.421 745.096Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.421 745.096L244.166 736.475L245.862 743.748L241.421 745.096Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.862 743.748L247.43 740.039L244.167 736.475L245.862 743.748Z",
    fill: "#B72D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.862 743.748L250.743 739.376L247.43 740.039L245.862 743.748Z",
    fill: "#A53027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.743 739.376L250.425 743.315L245.862 743.748L250.743 739.376Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.425 743.315L256.033 740.385L250.743 739.376L250.425 743.315Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.955 753.134L237.184 748.973L241.421 745.096L236.955 753.134Z",
    fill: "#5A1C17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.185 748.973L238.382 745.271L241.421 745.096L237.185 748.973Z",
    fill: "#721614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.381 745.271L240.64 742.302L240.349 745.157L238.381 745.271Z",
    fill: "#63202A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.875 770.002L221.733 769.778L223.695 773.938L211.875 770.002Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.689 774.425L211.875 770.002L223.695 773.938L209.689 774.425Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.164 778.909L223.695 773.938L209.689 774.425L223.164 778.909Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.469 382.987L366.375 393.26L368.434 413.848L362.337 427.395L360.736 413.255L357.206 416.127L359.469 382.987Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.205 416.127L359.468 435.467L354.189 451.808L354.658 439.135L348.395 439.845L349.265 437.73L357.205 416.127Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 303.586L124.283 307.425H108.1L117.146 303.586Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.496 31.9412L192.273 47.9487L197.762 46.6866L192.452 34.1858L188.496 31.9412Z",
    fill: "#A8968C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.273 47.9487L165.006 27.4689L186.417 47.6697L192.273 47.9487Z",
    fill: "#916362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.273 47.9487L190.239 39.6631L159.181 11.3942L165.006 27.4689L192.273 47.9487Z",
    fill: "#FFEFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.181 11.3942L165.006 27.4689V45.6574L159.518 35.339L159.181 11.3942Z",
    fill: "#898084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.006 27.4689L186.417 47.6697L165.006 45.6574V27.4689Z",
    fill: "#895B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 45.6574L186.417 47.6697L178.534 51.2245L163.575 45.6574Z",
    fill: "#F04D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.181 11.3942L164.487 10.4474L174.996 25.7892L159.181 11.3942Z",
    fill: "#FEEECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.244 0L164.487 10.4474L159.181 11.3942L147.244 0Z",
    fill: "#FEF6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.096 13.3857L159.18 11.3942L159.518 35.339L157.096 13.3857Z",
    fill: "#92878C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.096 13.3857L159.181 11.3942L147.244 0L157.096 13.3857Z",
    fill: "#776F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.944 66.8972L268.921 77.506L268.064 75.3587L271.944 66.8972Z",
    fill: "#640A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.466 67.2157L187.935 68.0749L195.273 71.4432L195.466 67.2157Z",
    fill: "#200F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.318 129.211L194.205 147.364L199.751 128.861L203.879 129.211H212.318Z",
    fill: "#10131F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.89 121.569L252.961 115.351H251.274H249.587L260.89 123.036V121.569Z",
    fill: "#C5BEB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72 109.962L251.274 115.351H249.588L227.449 103.307L228.865 99.716L234.405 105.377H237.273C237.273 105.377 237.104 107.099 238.116 107.436C239.129 107.773 243.008 109.12 243.008 109.12L244.695 110.636L246.72 109.962Z",
    fill: "#898381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.63 121.462L238.383 108.192L248.159 118.599L252.882 123.905L254.063 125.776L256.256 125.016L259.63 121.462Z",
    fill: "#B22827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.465 121.462L228.77 115.904L230.813 104.62H232.113L246.214 123.314L241.465 121.462Z",
    fill: "#3F131D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.937 94.4946L192.954 103.947L204.921 110.237L228.77 115.904L230.813 104.62L218.502 95.6945L201.937 94.4946Z",
    fill: "#180F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.083 50.5193L192.452 34.1858L203.267 48.4726L214.083 50.5193Z",
    fill: "#F04F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.267 48.4726L192.451 34.1858L192.272 47.9487L203.267 48.4726Z",
    fill: "#981B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.417 47.6697L201.093 53.0863L189.453 51.8447L186.417 47.6697Z",
    fill: "#F79233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.093 57.9702L189.454 51.8447L201.093 53.0863V57.9702Z",
    fill: "#F79233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.441 58.5597L201.093 53.0863V57.9702L214.441 58.5597Z",
    fill: "#FCB457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.441 58.5597L201.093 57.9702L209.697 63.191L214.441 58.5597Z",
    fill: "#FEC971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.441 58.5597L209.697 63.191L217.161 68.0749L214.441 58.5597Z",
    fill: "#EF3B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.417 47.6697L203.267 48.4726L214.441 58.5597L201.093 53.0863L186.417 47.6697Z",
    fill: "#F0524C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.161 68.0749L213.324 72.9589L209.697 63.191L217.161 68.0749Z",
    fill: "#8F191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.093 57.9702L209.697 63.191L207.588 66.2224L201.093 57.9702Z",
    fill: "#8F191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.323 72.9589L207.588 66.2224L209.697 63.191L213.323 72.9589Z",
    fill: "#600811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 51.8447L201.093 57.9702L203.148 60.5806H190.128L189.454 51.8447Z",
    fill: "#911A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.453 63.191L199.155 64.836L187.935 68.0749L189.453 63.191Z",
    fill: "#57101F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.162 68.0749L213.324 72.9589L233.989 75.3587L217.162 68.0749Z",
    fill: "#9E1D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.935 68.0749L207.588 66.2224L201.937 64.033L187.935 68.0749Z",
    fill: "#2E1215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.334 65.633L217.161 68.0749L240.378 68.917L216.334 65.633Z",
    fill: "#F37456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.947 72.1539L217.161 68.0749L240.378 68.917L225.947 72.1539Z",
    fill: "#F37760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.378 68.917L233.988 75.3587L225.947 72.1539L240.378 68.917Z",
    fill: "#F05248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.378 68.917L228.864 65.1277L216.334 65.633L240.378 68.917Z",
    fill: "#F16252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.441 58.5597L216.335 65.633L229.181 65.1277L214.441 58.5597Z",
    fill: "#F04F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.378 68.917L241.327 67.7802H236.924L240.378 68.917Z",
    fill: "#F05248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.864 65.1277L236.924 67.7802H240.757L238.492 67.275L228.864 65.1277Z",
    fill: "#F9A479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.572 64.033L238.226 67.2157L228.864 65.1277L230.572 64.033Z",
    fill: "#F9A46F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.267 48.4726L214.083 50.5193L214.441 58.5597L203.267 48.4726Z",
    fill: "#EF4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.083 50.5193L214.441 58.5597H221.811L214.083 50.5193Z",
    fill: "#EF423B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.865 65.1277L214.441 58.5597H221.811L228.865 65.1277Z",
    fill: "#EE342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.417 47.6697L190.128 60.5806L189.453 51.8447L186.417 47.6697Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.588 66.2224L203.148 60.5806L201.937 64.033L207.588 66.2224Z",
    fill: "#710F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.148 60.5806L189.454 63.191L199.155 64.836L203.148 60.5806Z",
    fill: "#721011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.298 72.3905L203.148 75.3587H206.091L209.697 71.7168L207.588 66.2224L197.298 67.1924V72.3905Z",
    fill: "#F79233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.937 64.033L203.148 60.5806L199.155 64.836L201.937 64.033Z",
    fill: "#710F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 63.191L190.128 60.5806H203.148L189.454 63.191Z",
    fill: "#630F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.879 67.0224L206.597 68.0749L207.588 66.2224L203.879 67.0224Z",
    fill: "#600811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.128 60.5806L189.453 63.191L181.672 60.5806H190.128Z",
    fill: "#721011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.453 63.191L187.935 68.0749L181.672 60.5806L189.453 63.191Z",
    fill: "#630F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.588 66.2224L200.429 66.8972C200.429 66.8972 198.695 73.1483 204.193 72.9589C201.336 69.5625 202.485 68.3486 202.485 68.3486L207.588 66.2224Z",
    fill: "#801517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.787 67.7802C206.787 67.7802 204.573 66.3908 202.169 68.3486C201.6 69.4854 201.094 72.1379 204.478 72.9589C205.712 72.9868 207.926 72.4115 207.356 69.5906C207.166 68.4749 206.787 67.7802 206.787 67.7802Z",
    fill: "#21100F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 68.3486C203.497 68.3486 205.964 67.0224 206.344 69.4132C206.344 70.1444 203.497 70.4959 203.497 68.3486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.273 67.3832C195.273 67.3832 192.87 67.7802 195.273 71.4432L197.298 72.3905C197.298 72.3905 197.089 67.634 198.373 67.302C196.331 67.6599 195.273 67.3832 195.273 67.3832Z",
    fill: "#630C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 68.6644L195.273 67.3832L200.429 66.8972L200.17 68.6644Z",
    fill: "#3E1315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.323 72.9589L208.994 72.1731L207.588 66.2224L213.323 72.9589Z",
    fill: "#2F1211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.588 66.2224L206.597 68.0749L208.995 72.1731L207.588 66.2224Z",
    fill: "#9E1D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 77.506V92.4947L254.738 89.1264L243.604 77.506Z",
    fill: "#9E1D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.197 88.2844L254.738 89.1264L257.943 79.0354L265.197 83.232V88.2844Z",
    fill: "#EF4024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 77.506L257.943 79.0354L254.738 89.1264L243.604 77.506Z",
    fill: "#F15A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.724 75.3587L254.738 76.8324L257.943 79.0354L243.604 77.506L239.724 75.3587Z",
    fill: "#F9A246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.065 75.3587L265.197 83.232V88.2844L272.645 89.1264L268.065 75.3587Z",
    fill: "#EF4225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.967 75.3587H268.065L265.197 83.232L259.967 75.3587Z",
    fill: "#BE2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.292 65.9274C247.123 66.4327 245.272 75.8346 245.272 75.8346L254.738 76.8324L257.943 79.0354L254.063 72.9631L247.292 65.9274Z",
    fill: "#640A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 62.0963L247.291 65.9274L245.272 75.8346L239.724 75.3587L243.604 62.0963Z",
    fill: "#941A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.943 70.1309L243.604 62.0963L254.063 72.9631L259.967 75.3587L257.943 70.1309Z",
    fill: "#F15737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.197 83.232L259.967 75.3587L254.063 72.9631L257.943 79.0354L265.197 83.232Z",
    fill: "#A31E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.943 70.1309L268.064 75.3587H259.967L257.943 70.1309Z",
    fill: "#F1573B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.004 62.7083L268.064 75.3588L257.943 70.1309L263.004 62.7083Z",
    fill: "#F37760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.945 66.8972L268.065 75.3588L263.004 62.7083L271.945 66.8972Z",
    fill: "#F26340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.064 90.4737L272.645 89.1264L265.197 88.2844L254.738 89.1264L243.604 92.4947L225.947 97.3786L230.813 97.4267L250.773 91.3158L257.099 89.8001L266.377 89.1264L268.064 90.4737Z",
    fill: "#4C1A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 95.8629L208.854 87.2739L213.323 95.8629H203.497Z",
    fill: "#660916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.947 97.3786L213.324 95.8629L221.811 90.1369L225.947 97.3786Z",
    fill: "#701123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.854 87.2739L221.811 90.1369L213.323 95.8629L208.854 87.2739Z",
    fill: "#79121F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.181 90.1369H221.811L225.947 97.3786L229.181 90.1369Z",
    fill: "#720E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.724 75.3587L243.604 77.506L229.181 90.1369L239.724 75.3587Z",
    fill: "#7E141E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 92.4947L235.046 85.0003L243.604 77.506V92.4947Z",
    fill: "#6E0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.046 85.0003L233.163 95.4429L243.604 92.4947L235.046 85.0003Z",
    fill: "#6B101F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.947 97.3786L229.181 90.1369L233.162 95.4429L225.947 97.3786Z",
    fill: "#6A1022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.046 85.0003L229.181 90.1369L233.162 95.4429L235.046 85.0003Z",
    fill: "#6F0F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.988 75.3587L241.326 67.7802L239.724 75.3587H233.988Z",
    fill: "#7C1318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.181 90.1369L233.988 75.3587H239.724L229.181 90.1369Z",
    fill: "#911A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.635 83.3162L232.113 80.9645L229.181 90.1369L219.635 83.3162Z",
    fill: "#EF3829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.854 87.2739L219.635 83.3162L221.811 90.1369L208.854 87.2739Z",
    fill: "#BD4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.181 90.1369H221.811L219.635 83.3162L229.181 90.1369Z",
    fill: "#C12126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 95.8629L194.205 99.3996L208.854 87.2739L203.497 95.8629Z",
    fill: "#3F131D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.128 90.2216L197.298 89.0931L208.854 87.2739L194.205 99.3996L190.128 90.2216Z",
    fill: "#6B0C11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.549 80.9645L190.128 90.2216L197.298 89.0931L183.549 80.9645Z",
    fill: "#E52525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.801 72.6289L187.935 68.0749L183.549 80.9645L176.801 72.6289Z",
    fill: "#81151F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.682 89.1264L190.128 90.2216L183.549 80.9645L180.682 89.1264Z",
    fill: "#F47945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 93.7578L180.682 89.1264L190.128 90.2216L189.454 93.7578Z",
    fill: "#C62127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.205 99.3996L189.454 93.7578L190.128 90.2216L194.205 99.3996Z",
    fill: "#9F1D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.453 103.947L194.205 99.3996L189.453 93.7578L174.608 101.757L189.453 103.947Z",
    fill: "#EE3224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.681 89.1264L189.453 93.7578L174.608 101.757L180.681 89.1264Z",
    fill: "#88181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.549 80.9645H170.054L176.801 72.6289L183.549 80.9645Z",
    fill: "#EB2425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 86.7266L180.682 89.1264L166.005 102.263V86.7266Z",
    fill: "#7D131E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.609 101.757L166.005 102.263L180.682 89.1264L174.609 101.757Z",
    fill: "#901A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.054 80.9645L166.005 86.7266L180.682 89.1264L170.054 80.9645Z",
    fill: "#EF3A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.549 80.9645L180.681 89.1264L170.054 80.9645H183.549Z",
    fill: "#EF4643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 86.7266L170.054 80.9645L157.096 80.0322L166.005 86.7266Z",
    fill: "#F2695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.654 85.5931L166.005 86.7266L157.097 80.0322L150.654 85.5931Z",
    fill: "#F5876F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.047 89.9766L157.097 80.0322L150.654 85.5931L114.047 89.9766Z",
    fill: "#F2695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 86.7266L159.865 92.4654L114.047 89.9766L150.654 85.5931L166.005 86.7266Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 102.263V86.7266L159.865 92.4654L166.005 102.263Z",
    fill: "#5E0813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.813 115.009L161.994 95.8629L157.096 108.662L121.813 115.009Z",
    fill: "#EF3E37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 102.263L157.096 108.662L161.994 95.8629L166.005 102.263Z",
    fill: "#951B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.865 92.4654L161.994 95.8629L121.813 115.009L159.865 92.4654Z",
    fill: "#15172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.096 80.0322L167.186 74.1378L170.054 80.9645L157.096 80.0322Z",
    fill: "#DF282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.802 72.6289L167.186 74.1378L170.054 80.9645L176.802 72.6289Z",
    fill: "#A51E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 57.9702L167.186 74.1378L176.802 72.6289L163.575 57.9702Z",
    fill: "#700F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.673 60.5806L176.802 72.6289L163.575 57.9702L181.673 60.5806Z",
    fill: "#81151E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.935 68.0749L176.801 72.6289L181.672 60.5806L187.935 68.0749Z",
    fill: "#8A1A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.273 71.4432L187.935 68.0749L185.457 75.3587L195.273 71.4432Z",
    fill: "#6E1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.602 75.8346L185.457 75.3587L195.273 71.4432L204.602 75.8346Z",
    fill: "#A61E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.324 72.9589L206.091 75.3587L209.341 70.7906L213.324 72.9589Z",
    fill: "#EB4828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.887 79.971L207.448 82.7478L208.854 87.2739L197.298 89.0931L183.549 80.9645L183.887 79.971Z",
    fill: "#EF472E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.635 83.3162L213.323 72.9589L207.448 82.7478L208.854 87.2739L219.635 83.3162Z",
    fill: "#EF3C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.091 75.3587L207.448 82.7478L213.324 72.9589L206.091 75.3587Z",
    fill: "#EF4330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.887 79.971L185.457 75.3587H206.091L183.887 79.971Z",
    fill: "#ED2224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.448 82.7478L206.091 75.3587L183.887 79.971L207.448 82.7478Z",
    fill: "#EF3925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.324 72.9589L233.989 75.3587L219.635 83.3162L213.324 72.9589Z",
    fill: "#F04B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.113 80.9645L219.635 83.3162L233.988 75.3587L232.113 80.9645Z",
    fill: "#EE2525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.417 47.6697L181.672 60.5806H190.128L186.417 47.6697Z",
    fill: "#971D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 57.9702L186.417 47.6697L181.673 60.5806L163.575 57.9702Z",
    fill: "#EF4643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.751 122.611L157.096 108.662L166.005 102.263L164.487 115.009L137.751 122.611Z",
    fill: "#EF433F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.621 112.463L164.487 115.036L166.005 102.289L182.621 112.463Z",
    fill: "#EC2130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.609 101.757L166.005 102.263L182.622 112.437L174.609 101.757Z",
    fill: "#851619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.453 103.947L182.621 112.437L174.608 101.757L189.453 103.947Z",
    fill: "#700E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.016 129.211L182.622 112.437L190.128 114.893L159.016 129.211Z",
    fill: "#EF403E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.879 129.211L194.205 118.599L190.423 128.03L203.879 129.211Z",
    fill: "#CA2327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.128 114.893L190.424 128.03L194.205 118.599L190.128 114.893Z",
    fill: "#DE2D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.016 129.211L190.424 128.03L190.128 114.893L159.016 129.211Z",
    fill: "#EE2D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.205 118.599L211.384 120.824L203.879 129.211L194.205 118.599Z",
    fill: "#DA2727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.089 126.682L254.063 129.211L252.882 123.905C252.882 123.905 254.232 120.692 254.063 120.824C253.895 120.956 256.256 125.016 256.256 125.016L259.63 121.462L263.004 125.016L270.089 126.682Z",
    fill: "#FCE7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.016 112.437V118.599L263.004 125.016L259.63 121.462L264.016 112.437Z",
    fill: "#94715F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.474 126.067L266.546 118.726L264.016 112.437V118.599L263.004 125.016L267.474 126.067Z",
    fill: "#D1B9A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.159 118.599L252.882 123.905L254.063 129.211L243.604 125.016L248.159 118.599Z",
    fill: "#B79686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.757 116.914L245.272 122.666L243.015 126.067L237.658 123.314L240.757 116.914Z",
    fill: "#CCC4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.392 115.009L239.125 120.284L237.658 123.314L223.288 116.327L228.77 115.904L230.446 113.378L236.392 119.252V115.009Z",
    fill: "#877F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.27 128.148L186.417 145.544L199.855 128.858L190.423 128.03L187.27 128.148Z",
    fill: "#10131F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 103.947L190.128 114.893L182.622 112.437L189.454 103.947Z",
    fill: "#80181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.205 118.599L197.86 110.515L189.454 103.947L190.128 114.893L194.205 118.599Z",
    fill: "#BE2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.384 120.824L197.859 110.515L194.205 118.599L211.384 120.824Z",
    fill: "#7E1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.089 126.682L268.921 129.211L256.087 133.082L254.063 129.211L270.089 126.682Z",
    fill: "#EF3926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 122.611L243.604 125.016L254.063 129.211L256.087 133.082L242.795 129.211L236.34 122.611Z",
    fill: "#EF423B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.921 129.211L257.943 144.702L256.087 133.082L268.921 129.211Z",
    fill: "#BA2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.984 140.787L257.943 144.702L268.921 129.211L265.984 140.787Z",
    fill: "#AC1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.967 154.807L265.984 140.787L257.943 144.702L259.967 154.807Z",
    fill: "#E42A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.795 129.211L256.088 133.082L257.943 144.702L242.795 129.211Z",
    fill: "#610D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.967 154.807L252.882 146.532L257.943 144.702L259.967 154.807Z",
    fill: "#590F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 122.611L257.943 144.702L252.882 146.532L236.34 122.611Z",
    fill: "#5D0B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.774 154.807L252.882 146.532L236.34 122.611L243.351 143.187L249.774 154.807Z",
    fill: "#4F131A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.384 120.824L228.356 131.903L212.058 129.211H203.879L211.384 120.824Z",
    fill: "#5D0C15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.351 143.187L228.356 131.903L239.908 133.082L243.351 143.187Z",
    fill: "#5C0D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.384 120.824L239.908 133.082L228.356 131.903L211.384 120.824Z",
    fill: "#4E1316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 122.611L211.384 120.824L239.908 133.082L236.34 122.611Z",
    fill: "#680F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.859 110.515L217.161 113.378L211.384 120.824L197.859 110.515Z",
    fill: "#680F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 122.611L211.384 120.824L217.162 113.378L236.34 122.611Z",
    fill: "#7E1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 103.947L195.274 102.263L197.86 110.515L189.454 103.947Z",
    fill: "#C39F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.77 115.904L226.812 113.378L223.656 111.862V116.504L228.77 115.904Z",
    fill: "#656572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.662 109.42L218.502 111.862L217.161 113.378L223.656 116.504V113.378L220.662 109.42Z",
    fill: "#666876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.816 112.437L215.332 107.097L218.502 111.862L217.161 113.378L210.816 112.437Z",
    fill: "#5F5F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.273 102.263L205.395 111.862L197.859 110.515L195.273 102.263Z",
    fill: "#887475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.249 110.743L206.597 103.947L204.921 107.231L201.937 104.62L201.53 108.196L205.395 111.862L210.816 112.437L212.249 110.743Z",
    fill: "#7D6777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 95.8629L195.274 102.263L189.454 103.947L194.205 99.3996L203.497 95.8629Z",
    fill: "#47313A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.448 99.9048L203.497 95.8629H213.323L209.707 100.915L208.41 97.3786L207.448 99.9048Z",
    fill: "#503F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.333 99.9048L213.324 95.8629L218.502 96.4847L215.333 99.9048Z",
    fill: "#503F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.811 101.757L217.205 97.8839L218.502 96.4847L225.947 97.3786L221.811 101.757Z",
    fill: "#503F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.064 90.4737L267.474 94.4946H264.016V89.2979L266.377 89.1264L268.064 90.4737Z",
    fill: "#898381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.004 104.62L267.474 94.4946H264.016L263.004 104.62Z",
    fill: "#C5BEB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.642 94.8106L264.016 94.4946L263.004 104.62L260.642 94.8106Z",
    fill: "#FCE5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1 89.8001L260.642 94.8106L264.016 94.4946V89.2979L257.1 89.8001Z",
    fill: "#6C5957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.773 96.4847L256.425 95.6945L257.099 89.8001L251.607 91.116L250.773 96.4847Z",
    fill: "#7F6C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.936 103.737L256.425 95.6945L250.773 96.4847L253.936 103.737Z",
    fill: "#745D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.004 104.62L256.425 95.6945L257.1 89.8001L260.642 94.8106L263.004 104.62Z",
    fill: "#302424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.774 103.737L250.774 96.4847L251.607 91.116L244.172 93.3367L249.774 103.737Z",
    fill: "#7F7373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.254 98.8522L246.9 98.4019L244.172 93.3367L242.254 98.8522Z",
    fill: "#38292F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.125 105.378L242.254 98.8522L244.172 93.3367L235.629 95.8629L239.125 105.378Z",
    fill: "#665255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.545 103.737L236.55 98.3786L235.629 95.8629L230.813 97.4267L233.545 103.737Z",
    fill: "#5B484B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.021 100.217L230.813 97.4267L226.904 97.2102L225.947 97.3786L223.402 100.073L226.812 103.737L232.021 100.217Z",
    fill: "#4F3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.113 104.62L238.383 108.192L248.159 118.599L245.272 122.666L240.757 116.914L232.113 104.62Z",
    fill: "#580F1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 62.0963L241.327 67.7802L239.724 75.3587L243.604 62.0963Z",
    fill: "#640A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.083 50.5193H224.408L221.811 58.5597L214.083 50.5193Z",
    fill: "#EF3733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.865 65.1277L221.811 58.5597L224.408 50.5193L228.865 65.1277Z",
    fill: "#F04C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.813 55.823L228.864 65.1277L227.477 60.5806L230.813 55.823Z",
    fill: "#D72827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.408 50.5193L230.813 55.823L227.478 60.5806L224.408 50.5193Z",
    fill: "#F36E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.186 74.1378L100.479 89.2979L114.047 89.9766L157.096 80.0322L167.186 74.1378Z",
    fill: "#471319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.186 74.1378L153.948 56.2127L163.575 57.9702L167.186 74.1378Z",
    fill: "#724E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.186 74.1378L164.487 74.7512L146.59 62.7083L153.948 56.2127L167.186 74.1378Z",
    fill: "#62383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.289 51.2245L153.948 56.2127L146.59 62.7083L136.289 51.2245Z",
    fill: "#744D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.026 42.3526L136.289 51.2245L153.948 56.2127L140.026 42.3526Z",
    fill: "#FEEBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 45.6574L153.948 56.2127L140.026 42.3526L163.575 45.6574Z",
    fill: "#FDDFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 57.9702L153.948 56.2127L163.575 45.6574L170.367 54.9075L163.575 57.9702Z",
    fill: "#FFDDB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.534 51.2245L170.367 54.9075L163.575 45.6574L178.534 51.2245Z",
    fill: "#FDF8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.904 35.339L140.026 42.3526L163.575 45.6574L141.904 35.339Z",
    fill: "#745658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 45.6574L142.666 33.1377L141.904 35.339L163.575 45.6574Z",
    fill: "#8F7670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.666 33.1377L116.177 37.4052L141.904 35.339L142.666 33.1377Z",
    fill: "#A58D89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 37.4052L121.813 39.5857L141.904 35.339L116.177 37.4052Z",
    fill: "#B99E94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.904 35.339L140.026 42.3526L124.189 43.0954L121.813 39.5857L141.904 35.339Z",
    fill: "#74575E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 37.4052L100.479 27.1944L121.813 36.4971L116.177 37.4052Z",
    fill: "#D4B6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.479 27.1944L114.869 39.9448L116.177 37.4052L100.479 27.1944Z",
    fill: "#6F5656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.189 43.0954L114.869 39.9448L116.177 37.4052L121.813 39.5857L124.189 43.0954Z",
    fill: "#664E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.026 42.3526L86.4932 43.0788L96.3917 46.6866L136.289 51.2245L140.026 42.3526Z",
    fill: "#F7D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.59 62.7083L136.289 51.2245L116.177 55.55L146.59 62.7083Z",
    fill: "#673639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.289 51.2245L96.3916 46.6866L116.177 55.55L136.289 51.2245Z",
    fill: "#603135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 55.55L85.2729 47.3415L96.3918 46.6866L116.177 55.55Z",
    fill: "#62383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2729 47.3415L66.9331 27.2523L91.3213 46.9853L85.2729 47.3415Z",
    fill: "#72575A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3213 43.0133L66.9331 27.2523L86.4932 43.0788L91.3213 43.0133Z",
    fill: "#FEF6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.487 74.7512L146.59 62.7083L148.714 78.3358L164.487 74.7512Z",
    fill: "#4B1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.421 73.6389L146.59 62.7083L148.714 78.3358L129.421 73.6389Z",
    fill: "#5D0D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.687 62.6167L129.421 73.6389L146.59 62.7083L132.687 62.6167Z",
    fill: "#7A1129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.686 62.6167L122.67 62.0963L105.385 70.1309L129.421 73.6389L132.686 62.6167Z",
    fill: "#BF2126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6494 60.7445L122.67 62.0963L105.385 70.1309L96.6494 60.7445Z",
    fill: "#E01F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.714 78.3358L131.383 79.971L105.385 70.1309L129.421 73.6389L148.714 78.3358Z",
    fill: "#5B0F14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6496 60.7445L92.6309 69.5906L105.385 70.1309L96.6496 60.7445Z",
    fill: "#771228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6308 69.5906L79.127 68.0749L92.6308 59.4808L96.6495 60.7445L92.6308 69.5906Z",
    fill: "#6A1424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6308 59.4808L64.0161 58.5597L89.9411 61.1927L92.6308 59.4808Z",
    fill: "#DB383E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.127 68.0749L89.9411 61.1927L64.0161 58.5597L55.7681 59.4808L79.127 68.0749Z",
    fill: "#A91E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1433 44.3101L64.0161 58.5597L55.7681 59.4808L40.1433 44.3101Z",
    fill: "#B8202C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1433 44.3101L52.8973 60.4753L55.7681 59.4808L40.1433 44.3101Z",
    fill: "#5B121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1272 68.0749L55.7682 59.4808L52.8975 60.4753L76.4433 70.5221L79.1272 68.0749Z",
    fill: "#46141B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.383 79.971L105.385 70.1309L87.8882 73.0747L131.383 79.971Z",
    fill: "#50131C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4434 70.5221L79.1273 68.0749L105.385 70.1309L87.8886 73.0747L76.4434 70.5221Z",
    fill: "#3A1217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4932 43.0788L96.3917 46.6866L91.3212 46.9853L86.4932 43.0788Z",
    fill: "#603135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8821 251.307L77.0244 268.515L81.1792 274.505L80.7406 267.198L83.2037 268.896L82.4636 260.69L77.8821 251.307Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2944 227.809V233.077L70.849 221.48L64.2944 227.809Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.408 74.1313H164.45L152.5 78.4783L166.195 84.1168L177.408 74.1313Z",
    fill: "#7B5F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.473 102.501L169.927 104.503L146.358 108.802L159.217 129.441L189.473 102.501Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 101.73L146.358 108.802L141.545 89.5238L126.772 101.73Z",
    fill: "#744D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.292 87.592L146.358 108.802L169.927 104.503L162.292 87.592Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.499 78.4783L166.195 84.1168L162.292 87.592L141.544 89.5238L152.499 78.4783Z",
    fill: "#6D5531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.358 108.802L141.544 89.5238L162.292 87.592L146.358 108.802Z",
    fill: "#62383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1978 94.7552L92.0824 93.5574L88.0989 97.3777L64.1978 94.7552Z",
    fill: "#967546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 101.73L105.195 94.4859L92.0826 93.5574L88.0991 97.3777L126.772 101.73Z",
    fill: "#7B5F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1978 94.7552L105.029 80.1377L92.0824 93.5574L64.1978 94.7552Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 101.73L121.461 88.752L105.195 94.4859L126.772 101.73Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.029 80.1377L105.195 94.4859L92.0825 93.5574L105.029 80.1377Z",
    fill: "#D3A96F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.461 88.752L105.029 80.1377L105.195 94.4859L121.461 88.752Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.545 89.5238L121.461 88.752L126.772 101.73L141.545 89.5238Z",
    fill: "#8F683F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.029 80.1377L117.145 76.8213L121.461 88.752L105.029 80.1377Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.545 89.5238L129.262 82.4598L121.461 88.752L141.545 89.5238Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.499 78.4783L140.217 80.4668L141.545 89.5238L152.499 78.4783Z",
    fill: "#7B5F38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.262 82.4598L140.217 80.4668L141.545 89.5238L129.262 82.4598Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 76.8213L129.262 82.4598L121.461 88.752L117.146 76.8213Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.499 78.4783L137.727 72.3473L129.262 82.4598L140.217 80.4668L152.499 78.4783Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 76.8213L137.727 72.3473L129.262 82.4598L117.146 76.8213Z",
    fill: "#F2C07B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 101.73L107.436 124.691L133.411 116.378L126.772 101.73Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.358 108.802L133.412 116.378L126.772 101.73L146.358 108.802Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.217 129.441L183.603 135.973L194.903 124.691L159.217 129.441Z",
    fill: "#6B3020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.412 116.378L159.217 129.441L146.358 108.802L133.412 116.378Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.773 101.73L101.986 104.651L93.0786 115.971L107.436 113.211V124.691L126.773 101.73Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.603 135.973L166.195 150.062L169.927 132.31L183.603 135.973Z",
    fill: "#915933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.87 158.513L159.217 139.789L166.195 150.062L153.87 158.513Z",
    fill: "#835635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.217 129.441V139.789L166.195 150.062L169.927 132.31L159.217 129.441Z",
    fill: "#8B613B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.113 156.856L153.87 158.513L159.218 139.789L146.379 140.369L145.113 156.856Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.218 129.441L145.113 135.973L146.379 140.369L159.218 139.789V129.441Z",
    fill: "#8F683F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.503 142.606L145.113 135.973L146.379 140.369L145.113 156.856L131.503 142.606Z",
    fill: "#A98757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.941 179.06L153.87 158.513L145.113 156.856L138.941 179.06Z",
    fill: "#A98757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.503 142.606L138.889 167.958L145.113 156.856L131.503 142.606Z",
    fill: "#B4905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.461 172.432L138.889 167.958L138.941 179.06L121.461 172.432Z",
    fill: "#E3BD86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.113 156.856L138.941 179.06L138.889 167.958L145.113 156.856Z",
    fill: "#BB9965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.503 142.606L130.201 159.839L138.889 167.958L131.503 142.606Z",
    fill: "#BB9965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.984 152.216L131.503 142.606L130.201 159.839L115.984 152.216Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.461 172.432L130.201 159.839L138.889 167.958L121.461 172.432Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.984 152.216L121.461 172.432L130.201 159.839L115.984 152.216Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.283 184.694L138.941 179.06L121.461 172.432L124.283 184.694Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93 181.38L121.461 172.432L124.283 184.694L108.93 181.38Z",
    fill: "#E3B574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.195 164.81L108.929 181.38L121.461 172.432L105.195 164.81Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.984 152.216L105.195 164.81L121.461 172.432L115.984 152.216Z",
    fill: "#967546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.929 181.38H92.0825L105.195 164.81L108.929 181.38Z",
    fill: "#B28855"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0537 194.305L92.0825 181.38H108.929L99.0537 194.305Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.854 197.951L92.0824 181.38L99.0535 194.305L86.854 197.951Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.941 179.06L130.201 197.951L124.283 184.694L138.941 179.06Z",
    fill: "#E3B574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.93 181.38L117.146 202.922L124.283 184.694L108.93 181.38Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0537 194.305L117.146 202.922L108.93 181.38L99.0537 194.305Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.201 197.95L117.146 202.922L124.283 184.694L130.201 197.95Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 219.05L117.146 202.922L130.201 197.951L127.879 219.05Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0535 194.305L92.0824 205.352L86.854 197.95L99.0535 194.305Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7407 215.294L86.8543 197.951L92.0827 205.352L80.7407 215.294Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7407 241.586V215.294L96.4535 237.609L80.7407 241.586Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0827 205.352L96.4535 237.609L80.7407 215.294L92.0827 205.352Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 202.922L107.436 208.5L99.0537 194.305L117.146 202.922Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0825 205.352L107.436 208.5L99.0537 194.305L92.0825 205.352Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 219.05L113.328 228.44L117.146 202.922L127.879 219.05Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.773 241.586L127.879 219.05L113.328 228.44L126.773 241.586Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4533 237.609L113.328 228.44L92.0825 205.352L96.4533 237.609Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 208.5L99.0537 212.928L92.0825 205.352L107.436 208.5Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 202.922L107.436 208.5L99.0537 212.928L113.328 228.44L117.146 202.922Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4535 237.609L89.8143 263.238L80.7407 241.586L96.4535 237.609Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.506 285.773L89.814 263.238L107.436 269.866L100.506 285.773Z",
    fill: "#D9B47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.283 307.425L100.506 285.773L126.108 289.087L124.283 307.425Z",
    fill: "#CEAB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 269.866L126.108 289.087L100.506 285.773L107.436 269.866Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.814 263.238L113.328 250.423L107.436 269.866L89.814 263.238Z",
    fill: "#FFE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4532 237.609L113.328 250.423L89.814 263.238L96.4532 237.609Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.328 228.44V250.423L96.4531 237.609L113.328 228.44Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.773 241.586L113.328 250.423V228.44L126.773 241.586Z",
    fill: "#F5D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 249.098L126.773 241.586L113.328 250.423L127.879 249.098Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 269.866L126.772 263.238L113.328 250.423L107.436 269.866Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 249.098L126.773 263.238L113.328 250.423L127.879 249.098Z",
    fill: "#F5D096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 261.028L126.772 263.238L127.879 249.098L138.308 261.028Z",
    fill: "#DBA668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 274.505V261.028L126.772 263.238L138.308 274.505Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.109 289.087V274.505L113.328 275.931L126.109 289.087Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 263.238L126.108 274.505L107.436 269.866L126.772 263.238Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.328 275.931L107.436 269.866L126.108 274.505L113.328 275.931Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 274.505H126.108L126.772 263.238L138.308 274.505Z",
    fill: "#D9B47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.108 289.087H140.936L126.108 274.505V289.087Z",
    fill: "#D9B47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.283 307.425L140.936 289.087H126.109L124.283 307.425Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 318.914L124.283 307.425L146.405 306.321V318.914Z",
    fill: "#CEAB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.403 324.217L146.405 318.914L172.005 312.617L162.403 324.217Z",
    fill: "#8F683F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.984 329.077L162.403 324.217L172.005 312.617L182.984 329.077Z",
    fill: "#8B613B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 289.087L146.405 306.321L124.283 307.425L140.936 289.087Z",
    fill: "#D9B47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 285.773L140.936 289.087L146.405 306.321V285.773Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 274.505L140.936 289.087L126.108 274.505H138.308Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 285.773L138.308 274.505L140.936 289.087L146.405 285.773Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 318.914L160.411 302.123L146.405 285.773V318.914Z",
    fill: "#B4905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.005 312.617L160.411 302.123L146.405 318.914L172.005 312.617Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.984 329.077L194.935 320.847L172.005 312.617L182.984 329.077Z",
    fill: "#7B492E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 241.586L138.308 261.028L127.879 249.098L126.772 241.586Z",
    fill: "#77432B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.935 320.847L208.877 332.391L182.984 329.077L194.935 320.847Z",
    fill: "#77432B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.82 337.181L208.877 332.391L194.935 320.847L224.82 337.181Z",
    fill: "#6F3523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36 318.299L265.089 344.101L267.523 321.159L253.36 318.299Z",
    fill: "#6B3020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.121 332.391L269.958 339.903L267.523 321.159L284.121 332.391Z",
    fill: "#835635"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 344.101L269.958 339.903L267.523 321.159L265.089 344.101Z",
    fill: "#77432B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.777 349.183L265.089 344.101L269.958 339.903L284.121 332.391L286.777 349.183Z",
    fill: "#8F683F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.826 355.369L286.777 349.183L284.122 332.391L301.826 355.369Z",
    fill: "#A07D4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 344.101L274.605 359.788L284.121 361.555L286.777 349.182L265.089 344.101Z",
    fill: "#865C39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 372.16L301.826 355.369L292.974 363.764L305.146 372.16Z",
    fill: "#BB9965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.122 361.555L292.974 363.764L301.826 355.369L286.777 349.182L284.122 361.555Z",
    fill: "#B4905E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 372.16L290.54 382.102L307.58 400.44L305.146 372.16Z",
    fill: "#CEAB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.974 363.764L290.54 382.102L305.146 372.16L292.974 363.764Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.122 377.684L292.974 363.764L290.539 382.102L284.122 377.684Z",
    fill: "#BCA375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 359.788L284.122 377.684L292.974 363.764L284.122 361.555L274.605 359.788Z",
    fill: "#A1895F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 370.172V359.788L284.122 377.684L274.605 370.172Z",
    fill: "#947C54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58 400.44L290.54 413.254L299.06 391.271L307.58 400.44Z",
    fill: "#F5D096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.54 382.102V413.254L299.06 391.271L290.54 382.102Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 370.172L283.79 397.678L290.54 382.102L284.122 377.684L274.605 370.172Z",
    fill: "#E4CA98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.539 413.254L283.79 397.678L290.539 382.102V413.254Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.974 434.906L285.449 417.894L290.539 413.254L307.58 400.44L292.974 434.906Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.613 454.349L292.974 434.906L274.605 438.662L272.613 454.349Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.65 391.271L279.363 404.417L290.539 413.254L281.65 391.271Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.449 417.894L279.363 404.417L290.539 413.255L285.449 417.894Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.409 427.836L279.363 404.417L285.449 417.894L268.409 427.836Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.974 434.906L277.102 422.765L285.449 417.894L292.974 434.906Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 438.662L277.102 422.765L292.974 434.906L274.605 438.662Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.409 427.836L274.605 438.662L277.102 422.765L268.409 427.836Z",
    fill: "#FFDA9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.614 454.349L249.155 464.954L258.45 450.372L272.614 454.349Z",
    fill: "#E4CA98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.408 427.836L265.974 441.093L274.605 438.662L268.408 427.836Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.644 442.772L268.409 427.836L265.974 441.093L254.644 442.772Z",
    fill: "#ECC78E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.45 450.372L265.974 441.093L272.613 454.349L258.45 450.372Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 438.662L272.613 454.349L265.974 441.093L274.605 438.662Z",
    fill: "#F5D096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.644 442.772L258.45 450.372L265.974 441.093L254.644 442.772Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 464.954V448.826L258.45 450.372L249.155 464.954Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.644 442.772L249.155 448.826L258.45 450.372L254.644 442.772Z",
    fill: "#E4CA98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 464.954L219.942 466.501L234.549 459.431L249.155 464.954Z",
    fill: "#C7A36E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 448.826L234.549 459.43L249.155 464.954V448.826Z",
    fill: "#FEE4B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.942 466.501L201.131 459.431H234.549L219.942 466.501Z",
    fill: "#CEAB77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.155 448.826L214.41 459.43H234.549L249.155 448.826Z",
    fill: "#F5D096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.113 135.973L133.412 116.378L159.217 129.441L145.113 135.973Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.604 135.973H145.113L133.412 116.378L120.604 135.973Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.503 142.606L120.604 135.973H145.113L131.503 142.606Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 124.691L120.603 135.973L133.411 116.378L107.436 124.691Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.984 152.216L120.604 135.973L131.503 142.606L115.984 152.216Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 124.691L102.705 139.289L120.603 135.973L107.436 124.691Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7407 215.294L79.5532 197.951H86.8543L80.7407 215.294Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1187 179.06L92.0826 181.38L89.0774 190.905L84.1187 179.06Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5532 197.951L84.1187 179.06L89.0775 190.905L86.8543 197.951H79.5532Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2772 174.816L92.0826 181.38L84.1187 179.06L90.8681 163.581L97.2772 174.816Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.983 152.216L102.705 139.289L120.603 135.973L115.983 152.216Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9673 158.513L115.983 152.216L102.705 139.289L93.9673 158.513Z",
    fill: "#C52126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.195 164.81L115.983 152.216L93.9673 158.513L105.195 164.81Z",
    fill: "#771030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2769 174.816L93.9673 158.513L105.195 164.81L97.2769 174.816Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2241 164.206L93.9673 158.513L97.2769 174.816L91.2241 164.206Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.308 262.292L156.843 274.505H138.308V262.292Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.411 302.123L156.843 274.505H138.308L146.405 285.773L160.411 302.123Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21 279.477H167.636L156.843 274.505L160.411 302.123L177.21 279.477Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.562 298.961L177.21 279.477L160.411 302.123L181.562 298.961Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.498 317.101L181.562 298.961L160.411 302.123L172.005 312.617L184.498 317.101Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.099 279.477H177.21L181.562 298.961L198.099 279.477Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.929 300.004L198.099 279.477H214.81L201.929 300.004Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.562 298.961L201.929 300.004L198.099 279.477L181.562 298.961Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.497 317.101L201.929 300.004L181.562 298.961L184.497 317.101Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.018 315.644L201.929 300.004L184.498 317.101L204.018 315.644Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.619 327.907L204.018 315.644L184.498 317.101L194.935 320.847L207.619 327.907Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.81 279.477L219.336 298.256L201.929 300.004L214.81 279.477Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 280.54L219.336 298.256L233.785 296.599L229.781 280.54Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.811 279.477L229.781 280.54L219.337 298.256L214.811 279.477Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 280.54L233.785 296.599L229.781 280.54H247.537Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 297.571V280.54L233.785 296.599L247.537 297.571Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57 311.474H250.148L247.537 296.599L236.57 311.474Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.785 296.599L236.57 311.474L247.537 296.599H233.785Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.561 304.696L233.785 296.599L236.57 311.474L226.561 304.696Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.336 314.775L236.57 311.474L226.561 304.696L219.336 314.775Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.336 298.256L233.785 296.599L226.561 304.696L219.336 298.256Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.337 314.775L204.018 315.644L219.337 298.256V314.775Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.561 304.696L219.336 314.775V298.256L226.561 304.696Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.929 300.004L204.018 315.644L219.336 298.256L201.929 300.004Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.337 314.775L221.6 327.907L204.018 315.644L219.337 314.775Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.619 327.907H221.6L204.018 315.644L207.619 327.907Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.599 328.608L236.57 311.474L219.336 314.775L221.599 328.608Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.148 311.474L248.408 327.907L236.57 311.474H250.148Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.6 328.608L234.568 329.077L248.407 327.907L236.57 311.474L221.6 328.608Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 280.54L265.089 271.503L266.337 285.773L247.537 280.54Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 296.599L266.337 285.773L247.537 280.54V296.599Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.008 278.638L266.337 285.773L265.089 271.503L286.008 278.638Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.572 293.4L286.008 278.638L266.337 285.773L282.572 293.4Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.337 304.696C267.034 304.696 282.572 293.4 282.572 293.4L266.337 285.773V304.696Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.337 304.696L247.537 296.599L266.337 285.773V304.696Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.148 311.474L266.337 304.696L247.537 296.599L250.148 311.474Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.407 327.907L259.264 330.845L250.148 311.474L248.407 327.907Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.523 321.159L266.337 304.696L250.148 311.474L267.523 321.159Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.36 318.299L250.148 311.474L267.523 321.159L253.36 318.299Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.79 314.775L267.524 321.159L266.337 304.696L283.79 314.775Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.572 293.4L283.79 314.775L266.337 304.696L282.572 293.4Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.008 278.638L305.146 291.662L282.572 293.4L286.008 278.638Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 271.503L247.537 268.896V280.54L265.089 271.503Z",
    fill: "#F4816B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 280.54L247.537 268.896V280.54H229.781Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 268.896L214.811 279.477L229.781 280.54L247.537 268.896Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 291.662V310.778L282.572 293.4L305.146 291.662Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.789 314.775L305.146 310.778L282.572 293.4L283.789 314.775Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.121 332.391L283.789 314.775L267.523 321.159L284.121 332.391Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.974 330.845L283.79 314.775L284.121 332.391L292.974 330.845Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 310.778L292.974 330.845L283.79 314.775L305.146 310.778Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.082 303.132L305.146 291.662V310.778L319.082 303.132Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.045 318.946L319.082 303.132L305.146 310.778L326.045 318.946Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.856 331.259L305.146 310.778L326.045 332.391L309.856 331.259Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.666 344.101C337.796 342.537 326.046 318.946 326.046 318.946V332.391L338.666 344.101Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.146 310.778L326.045 318.946V332.391L305.146 310.778Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.856 331.259L292.974 330.845L305.146 310.778L309.856 331.259Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.826 356.473L309.856 331.259L292.974 330.845L301.826 356.473Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.826 356.473L317.342 344.101L309.857 331.259L301.826 356.473Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.827 356.473H301.826L317.342 344.101L324.827 356.473Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.122 332.391L301.826 356.473L292.974 330.845L284.122 332.391Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.827 356.473L326.046 332.391L309.856 331.259L317.342 344.101L324.827 356.473Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.046 332.391L338.666 344.101L324.827 356.473L326.046 332.391Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.976 359.178L338.666 344.101L324.827 356.473L343.976 359.178Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.747 377.684L343.976 359.178L324.827 356.473L331.747 377.684Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.86 377.684L324.827 356.473L331.747 377.684H313.86Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.826 356.473L313.86 377.684L324.827 356.473H301.826Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58 400.44L314.123 377.532L301.826 356.473L305.146 372.97L307.58 400.44Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.747 377.684L322.804 396.412L313.86 377.684H331.747Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.975 359.178L350.677 382.987L331.747 377.683L343.975 359.178Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L350.677 382.987L331.747 377.684L352.244 404.417Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.804 396.412L336.316 397.678L331.747 377.684L322.804 396.412Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L336.316 397.678L331.747 377.684L352.244 404.417Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58 400.44L322.804 396.412L313.86 377.684L307.58 400.44Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.316 397.678L329.56 416.827L322.804 396.412L336.316 397.678Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L329.56 416.827L336.316 397.678L352.244 404.417Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.394 418.816L352.244 404.417L329.56 416.827L348.394 418.816Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.951 416.127L329.56 416.827L322.804 396.412L317.951 416.127Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.394 418.816L335.794 438.662L329.56 416.827L348.394 418.816Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.802 432.516L335.794 438.662L348.395 418.816L344.802 432.516Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.752 464.954L344.933 431.876L335.794 438.662L334.752 464.954Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 445.732L335.794 438.662L334.752 464.954L326.394 445.732Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.951 416.127L335.794 438.662L329.56 416.827L317.951 416.127Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58 400.44L317.951 416.127L322.804 396.412L307.58 400.44Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.481 419.55L317.951 416.127L307.58 400.44L299.481 419.55Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.032 444.628L317.951 416.127L299.481 419.55L312.032 444.628Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.794 438.662L312.032 444.628L317.951 416.127L335.794 438.662Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 445.732L335.794 438.662L312.032 444.628L326.394 445.732Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.032 444.628L299.482 419.55L292.974 434.906L312.032 444.628Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.613 454.349L292.974 434.906L293.754 446.572L272.613 454.349Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.032 444.628L293.754 446.572L292.974 434.906L312.032 444.628Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.549 470.705L312.032 444.628L293.754 446.572L306.549 470.705Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.394 445.732L306.549 470.705L312.032 444.628L326.394 445.732Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.752 464.954L306.549 470.705L326.394 445.732L334.752 464.954Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.557 488.823L334.752 464.954L306.549 470.705L315.557 488.823Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.41 454.893L260.884 472.27L293.754 446.572L271.41 454.893Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.549 470.705L275.028 461.212L293.754 446.572L306.549 470.705Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.558 488.823L292.318 503.16L306.549 470.705L315.558 488.823Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.549 470.705L289.707 479.699L292.318 503.16L306.549 470.705Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.868 486.933L292.318 503.16L289.707 479.699L275.868 486.933Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.028 461.212L289.707 479.699L275.868 486.933L275.028 461.212Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.549 470.705L289.707 479.699L275.028 461.212L306.549 470.705Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.884 472.269L275.868 486.933L275.028 461.212L260.884 472.269Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.318 503.16H263.596L275.868 486.933L292.318 503.16Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.193 519.192L292.318 503.16H263.596L251.193 519.192Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 502.508L251.193 519.192L263.596 503.16L233.437 502.508Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 502.508L253.803 497.555L263.596 503.16L233.437 502.508Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.868 486.933L253.802 497.555L263.595 503.16L275.868 486.933Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.884 472.27L253.802 497.555L275.868 486.933L260.884 472.27Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 478.265L260.884 472.27L253.803 497.555L233.437 478.265Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 502.508V478.265L253.803 497.555L233.437 502.508Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.193 519.192L229.912 521.538L233.437 502.508L251.193 519.192Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.034 512.023L233.437 502.508L229.912 521.538L221.034 512.023Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 498.815L233.437 502.508L221.034 512.023L212.2 498.815Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 521.147L229.912 521.538L221.034 512.023L206.542 521.147Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.209 484.913L233.437 502.508L212.2 498.815L222.209 484.913Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.596 478.265L222.209 484.913L233.437 502.508V478.265H217.596Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 498.815L204.714 485.781L217.596 478.265L212.2 498.815Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 498.815L193.791 491.864L204.714 485.781L212.2 498.815Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 521.147L181.04 515.847L195.227 512.631L206.542 521.147Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.034 512.023L212.199 498.815L206.542 521.147L221.034 512.023Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.2 498.815L211.977 498.997L195.227 512.631L206.542 521.147L212.2 498.815Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 491.864L195.227 512.631L212.2 498.815L193.791 491.864Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.005 504.637L183.477 499.25L195.227 512.631L172.005 504.637Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 515.846L172.005 504.637L195.227 512.631L181.04 515.846Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 491.864L183.477 499.25L195.227 512.631L193.791 491.864Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.209 484.913L212.2 498.815L217.596 478.265L222.209 484.913Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.237 472.27L217.596 478.265L204.714 485.781L196.237 472.27Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.005 504.637L150.75 500.358L177.036 482.827L172.005 504.637Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 491.864L177.036 482.827L172.005 504.637L183.477 499.25L193.791 491.864Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.175 475.789L193.791 491.864L177.036 482.827L186.175 475.789Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.238 472.27L193.791 491.864L204.714 485.781L196.238 472.27Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.175 475.789L196.237 472.27L193.791 491.864L186.175 475.789Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 475.789L177.036 482.827L150.75 500.358L166.853 475.789Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.619 482.827L166.853 475.789L150.751 500.358L149.619 482.827Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.641 469.272L150.75 500.358L149.619 482.827L126.641 469.272Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.791 466.501L166.852 475.789L149.619 482.827L147.791 466.501Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.608 475.152L147.791 466.501L149.619 482.827L136.608 475.152Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 459.431L147.791 466.501L136.608 475.152L138.13 459.431Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.641 469.272L138.13 459.431L136.608 475.152L126.641 469.272Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5529 197.95L75.7947 194.305L70.4726 201.403L64.2944 227.809L73.0112 221.48L80.7404 241.586V215.294L79.5529 197.95Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1187 179.06L70.8494 181.38L60.0566 215.294L75.7951 194.305L79.5532 197.95L84.1187 179.06Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7407 241.586L83.2038 268.896L90.8682 283.841L89.8143 263.238L80.7407 241.586Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.885 472.27L249.155 464.954L271.411 454.893L260.885 472.27Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.437 478.265L249.155 464.954L260.884 472.269L233.437 478.265Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.942 466.501L249.155 464.954L233.437 478.265L219.942 466.501Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.942 466.501L233.437 478.265H217.596L219.942 466.501Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.155 454.128L196.238 472.269L186.175 475.789L165.155 454.128Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.036 482.827L165.155 454.128L186.175 475.789L177.036 482.827Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.791 466.501L165.155 454.128L177.036 482.827L166.852 475.789L147.791 466.501Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 459.431L152.23 447.721L147.791 466.501L138.13 459.431Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.155 454.128L152.23 447.721L147.791 466.501L165.155 454.128Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 459.431L120.604 444.628L126.641 469.272L138.13 459.431Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.13 441.093V459.431L120.604 444.628L138.13 441.093Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 447.721L138.13 441.093V459.431L152.23 447.721Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.155 454.128L152.23 427.745L138.13 441.093L152.23 447.721L165.155 454.128Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.54 426.4L138.13 441.093L120.604 444.628L132.54 426.4Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 417.673L120.603 444.628L132.54 426.4L117.146 417.673Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 409.995L117.146 417.673L132.54 426.4L133.522 409.995Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 427.745L132.54 426.4L138.13 441.093L152.23 427.745Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 409.995L152.23 427.745L132.54 426.4L133.522 409.995Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 402.263L152.23 427.745L133.522 409.995L140.936 402.263Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.641 469.272L104.891 444.628H120.603L126.641 469.272Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.145 417.673L104.891 444.628H120.603L117.145 417.673Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L349.024 438.662L334.752 464.954L344.933 431.876L352.244 404.417Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.568 329.077L247.161 344.432L248.407 327.907L234.568 329.077Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 402.263L115.766 386.3L133.522 409.995L140.936 402.263Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.145 417.673L115.766 386.3L133.522 409.995L117.145 417.673Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.891 444.628L75.7949 433.747H109.838L104.891 444.628Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 417.673L75.7949 433.746H109.838L117.146 417.673Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 386.3L104.891 401.987L117.145 417.673L115.766 386.3Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4531 425.71L117.145 417.673L104.89 401.987L96.4531 425.71Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4531 377.904L115.766 386.3L104.89 401.987L96.4531 377.904Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7949 433.747L104.891 401.987L96.4534 425.71L75.7949 433.747Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4534 377.904L66.3232 382.102L90.8681 391.271L96.4534 377.904Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.891 401.987L90.8682 391.271L96.4535 377.904L104.891 401.987Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7949 433.746L90.8681 391.271L104.891 401.987L75.7949 433.746Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3494 157.672L67.0194 170.533L53.0933 190.905L70.8491 181.38L84.1184 179.06L94.3494 157.672Z",
    fill: "#C52126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.436 117.485L79.553 129.441L70.8491 144.095L86.8541 137.861L97.277 151.232L102.705 139.289L107.436 124.691V117.485Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7603 160.124L78.3235 148.901L90.868 143.01L97.277 151.232L94.3495 157.672L78.3235 165.214L83.2036 156.856L68.7603 160.124Z",
    fill: "#BC2126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3231 382.102L41.2561 397.678L90.868 391.271L66.3231 382.102Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.795 433.746L62.4937 415.004L90.8682 391.271L75.795 433.746Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0622 394.475L62.4937 415.004L90.8682 391.271L66.0622 394.475Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2561 397.678L62.4935 415.004L66.062 394.475L41.2561 397.678Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7947 433.747L56.5747 459.421L60.0562 438.662L75.7947 433.747Z",
    fill: "#401211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4937 415.004L60.0566 438.662L75.7951 433.747L62.4937 415.004Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2562 397.678L28.3745 415.004L45.0859 418.87L41.2562 397.678Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4935 415.004L45.0858 418.87L41.2561 397.678L62.4935 415.004Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0565 438.662L45.0859 418.87L62.4936 415.004L60.0565 438.662Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.575 459.421L45.0859 418.87L60.0565 438.662L56.575 459.421Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3745 415.004L18.9744 435.514L45.0859 418.87L28.3745 415.004Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6413 447.721L45.0859 418.87L18.9744 435.514L34.6413 447.721Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.575 459.421L34.6414 447.721L45.086 418.87L56.575 459.421Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9744 435.514V461.212L34.6413 447.721L18.9744 435.514Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5749 459.421L18.9744 461.212L34.6413 447.721L56.5749 459.421Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7596 483.826L18.9744 461.212L37.7746 460.316L21.7596 483.826Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5749 459.421L51.8749 474.073L37.7747 460.317L56.5749 459.421Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8749 474.072L36.7302 484.912L37.7747 460.316L51.8749 474.072Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7595 483.826L36.7301 484.912L37.7746 460.316L21.7595 483.826Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.767 505.419L21.7595 483.826L36.7301 484.912L29.767 505.419Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8749 474.072L62.4936 495.046L36.7302 484.912L51.8749 474.072Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7302 484.913L49.6119 507.331L62.4936 495.046L36.7302 484.913Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7671 505.419L49.6118 507.331L36.7302 484.913L29.7671 505.419Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6118 533.746L29.7671 505.419L49.6118 507.331V533.746Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4935 495.046L75.7948 515.846L49.6118 507.331L62.4935 495.046Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6118 533.746L66.3232 552.168L62.4935 521.147L49.6118 533.746Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6118 507.331L62.4935 521.147L49.6118 533.746V507.331Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7948 515.846L62.4935 521.147L49.6118 507.331L75.7948 515.846Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3232 552.168L85.4717 567.113L81.3883 538.612L66.3232 552.168Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4937 521.147L81.3884 538.612L66.3233 552.168L62.4937 521.147Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.795 515.846L81.3884 538.613L62.4937 521.147L75.795 515.846Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8164 534.702L75.7949 515.846L81.3883 538.613L92.8164 534.702Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4717 567.114L106.799 579.974L97.8794 559.119L85.4717 567.114Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3882 538.612L97.8793 559.119L85.4716 567.113L81.3882 538.612Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8162 534.702L97.8793 559.119L81.3882 538.613L92.8162 534.702Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L97.8794 559.119L92.8164 534.702L115.766 550.343Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.799 579.974L128.351 586.925L119.242 569.547L106.799 579.974Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8794 559.119L119.243 569.547L106.799 579.974L97.8794 559.119Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L119.243 569.547L97.8794 559.119L115.766 550.343Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.351 586.925L147.968 588.402L133.522 574.413L128.351 586.925Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.243 569.547L133.522 574.413L128.351 586.925L119.243 569.547Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L133.522 574.413L119.242 569.547L115.766 550.343Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.968 588.402H172.005L162.413 576.15L147.968 588.402Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 574.413L162.414 576.15L147.968 588.402L133.522 574.413Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.791 567.114L162.414 576.15L133.522 574.413L147.791 567.114Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L147.791 567.113L133.522 574.413L115.766 550.343Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 552.863L147.791 567.113L142.2 555.557L166.853 552.863Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 550.343L142.199 555.557L147.791 567.113L115.766 550.343Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.413 576.15L166.852 552.863L147.791 567.113L162.413 576.15Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.005 588.402L193.791 594.659L177.036 582.581L172.005 588.402Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 576.15L177.036 582.581L172.005 588.402L162.414 576.15Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 552.863L177.036 582.58L162.414 576.15L166.853 552.863Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 594.659L203.123 608.127L201.132 584.318L193.791 594.659Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.036 582.581L201.132 584.318L193.791 594.659L177.036 582.581Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.596 478.265L219.942 466.501L196.237 472.269L217.596 478.265Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.131 459.431L196.237 472.269L219.942 466.501L201.131 459.431Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.155 454.128L201.131 459.431L196.238 472.269L165.155 454.128Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 552.863L189.084 558.077L177.036 582.58L166.853 552.863Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.132 584.318L189.084 558.077L177.036 582.581L201.132 584.318Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.227 582.581L201.131 584.318L189.083 558.077L218.227 582.581Z",
    fill: "#F26E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.123 608.127L211.155 596.223L201.131 584.318L203.123 608.127Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.227 582.581L211.155 596.223L201.131 584.318L218.227 582.581Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5751 459.421L62.4937 495.046L51.875 474.073L56.5751 459.421Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.227 582.581L229.912 603.956L211.155 596.223L218.227 582.581Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.123 608.127L208.228 627.591L211.155 596.223L203.123 608.127Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 603.956V625.853L221.034 616.816L229.912 603.956Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.204 606.737L229.912 603.956L211.155 596.223L217.204 606.737Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.229 627.591L217.204 606.737L211.155 596.223L208.229 627.591Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.034 616.816L217.204 606.737L229.912 603.956L221.034 616.816Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.09 627.591L221.034 616.816L217.204 606.737L208.09 627.591Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 625.853L208.09 627.591L221.034 616.816L229.912 625.853Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.283 307.425H108.1L121.461 320.041L124.283 307.425Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.405 318.914L127.879 313.733L121.461 320.041L124.283 307.425L146.405 318.914Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.099 307.425L107.436 324.217L121.461 320.041L108.099 307.425Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.747 336.368L120.05 331.259L107.436 324.217L112.747 336.368Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.872 320.812L120.05 331.259L107.436 324.217L118.872 320.812Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.619 327.907L224.82 337.181L221.599 327.907H207.619Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.161 344.432L265.089 344.101L259.264 330.845L247.161 344.432Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.408 327.907L259.264 330.845L247.161 344.432L248.408 327.907Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.82 337.181L247.537 352.828H227.953L224.82 337.181Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.568 329.077L224.82 337.181L221.6 327.907L234.568 329.077Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16 344.432L224.82 337.181L234.568 329.077L247.16 344.432Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 352.828L247.16 344.432L224.82 337.181L247.537 352.828Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 344.101L247.537 352.828L247.161 344.432L265.089 344.101Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 370.172L247.537 352.828L265.089 344.101L274.605 370.172Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.605 359.788V370.172L265.089 344.101L274.605 359.788Z",
    fill: "#6F3523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.974 377.684L274.605 370.172L265.089 363.764L265.974 377.684Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.953 352.828L208.877 359.178L229.781 361.555L227.953 352.828Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 352.828L229.781 361.555L227.954 352.828H247.537Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.089 363.764L241.488 368.736L265.974 377.684L265.089 363.764Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 352.828L241.488 368.736L265.089 363.764L247.537 352.828Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 361.555L241.488 368.736L247.537 352.828L229.781 361.555Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.174 372.933L265.974 377.684L241.488 368.736L231.174 372.933Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 361.555L231.174 372.933L241.488 368.736L229.781 361.555Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.877 359.178H187.655L201.929 367.128L208.877 359.178Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.781 361.555L219.336 372.933H231.174L229.781 361.555Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 221.48L136.523 234.139H126.641L127.879 221.48Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.772 241.586L126.641 234.139H131.612L148.228 249.098L136.656 246.005L136.97 249.098L138.308 262.292L126.772 241.586Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.843 274.505L138.308 262.292L137.104 250.423L145.113 258.121L156.843 274.505Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21 279.477L165.264 270.328L167.636 279.477H177.21Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.843 274.505L165.264 270.328L167.636 279.477L156.843 274.505Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.379 259.89L165.264 270.328L156.843 274.505L146.379 259.89Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 268.896L220.381 269.866L214.811 279.477L247.537 268.896Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.099 279.477L220.381 269.866L214.81 279.477H198.099Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21 279.477L220.381 269.866L198.099 279.477H177.21Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.264 270.328L206.758 272.899L177.21 279.477L165.264 270.328Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.104 250.423L147.552 256.168L177.21 263.433L167.636 265.268L165.264 270.328L146.379 259.89L137.104 250.423Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.758 272.899L232.313 257.6H246.117L236.57 263.238L247.537 268.896L220.381 269.866L206.758 272.899Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.264 270.328L193.921 265.944L203.328 262.03L214.811 260.145L206.455 268.399L206.758 272.899L165.264 270.328Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.083 303.132L342.932 331.524L326.046 318.946L319.083 303.132Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.666 344.101L342.932 331.524L326.046 318.946L338.666 344.101Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.678 382.987L356.161 361.555L343.976 359.178L350.678 382.987Z",
    fill: "#F69480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.666 344.101L352.244 351.639L342.932 331.524L338.666 344.101Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.161 361.555L352.244 351.639L343.976 359.178L356.161 361.555Z",
    fill: "#F4816B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.666 344.101L343.975 359.178L352.244 351.639L338.666 344.101Z",
    fill: "#F26E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.161 361.555L359.469 382.987H350.678L356.161 361.555Z",
    fill: "#F8A795"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L359.469 382.987H350.678L352.244 404.417Z",
    fill: "#F69480"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.244 404.417L357.206 416.127L349.024 438.662L352.244 404.417Z",
    fill: "#F26E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.468 382.987L357.205 416.127L352.244 404.417L359.468 382.987Z",
    fill: "#F4816B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.395 439.845L347.174 467.33L335.25 486.447L338.035 475.813L334.752 464.954L348.395 439.845Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.558 488.823L296.515 507.505L292.318 503.16L315.558 488.823Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.193 519.192H275.026L292.318 503.16L251.193 519.192Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.515 507.505L275.025 519.192L292.318 503.16L296.515 507.505Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 515.846L172.005 504.637L150.75 500.358L181.04 515.846Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.026 519.192L249.155 527.229L251.193 519.192H275.026Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 521.538L249.155 527.229L251.193 519.192L229.912 521.538Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 530.445L249.155 527.23L229.912 521.538L206.542 530.445Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 521.147V530.445L229.912 521.538L206.542 521.147Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.557 488.823L290.788 529.402L272.613 534.615L284.093 525.057L283.184 514.755L296.514 507.505L315.557 488.823Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.868 518.734L257.46 536.657L233.437 541.219L247.854 531.367L249.155 527.229L275.868 518.734Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 530.445L182.389 524.362L206.542 521.147V530.445Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.04 515.846L182.389 524.362L206.542 521.147L181.04 515.846Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.75 500.358L182.389 524.362L181.04 515.846L150.75 500.358Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.131 459.431L171.707 442.197L165.155 454.128L201.131 459.431Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.23 427.745L171.707 442.197L165.155 454.128L152.23 427.745Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.929 367.128L229.781 361.555L208.877 359.178L201.929 367.128Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.336 372.933L201.929 367.128L229.781 361.555L219.336 372.933Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.655 359.178L170.986 363.153L201.929 367.128L187.655 359.178Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.336 372.933L186.458 370.724L201.929 367.128L219.336 372.933Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.986 363.153L201.929 367.128L186.458 370.724L170.986 363.153Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.903 372.098L193.791 380.641L186.458 370.724L206.903 372.098Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 402.263L171.707 442.197L152.23 427.745L140.936 402.263Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.458 370.724L179.386 386.3L193.791 380.641L186.458 370.724Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.386 386.3L177.036 391.271L186.458 405.837L183.143 394.475L186.011 389.946L179.386 386.3Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.791 380.641L186.011 389.946L179.386 386.3L193.791 380.641Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.401 375.682L198.525 381.135L207.947 395.7L204.633 384.338L206.903 379.107L201.401 375.682Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.337 372.933L206.903 379.107L201.401 375.682L206.903 372.098L219.337 372.933Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.458 370.724L169.464 380.641L175.665 370.724H186.458Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.986 363.153L186.458 370.724H175.665L170.986 363.153Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.464 380.641L162.413 378.512L157.679 386.3L165.264 399.557L165.155 387.048L169.464 380.641Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.665 370.724L162.414 378.512L169.464 380.641L175.665 370.724Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.987 363.153L162.414 378.512L175.665 370.724L170.987 363.153Z",
    fill: "#92192B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.747 336.368L118.285 341.582L133.933 343.103L121.461 337.639L120.05 331.259L112.747 336.368Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.879 313.733L126.772 321.786L132.385 336.17L133.897 321.341L146.405 318.914L127.879 313.733Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.537 268.896L284.833 267.393L304.766 274.483L289.359 274.021L286.008 278.638L265.089 271.503L247.537 268.896Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.123 281.796L286.008 278.638L305.145 291.662L319.082 303.132V293.4L332.356 298.256L314.123 281.796Z",
    fill: "#F05C4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.455 306.95L319.083 303.132L342.932 331.524L341.995 319.69L359.468 330.845L345.455 306.95Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.161 361.555L352.244 351.639L342.932 331.524L366.605 356.473L370 382.987L360.6 365.26L359.468 382.987L356.161 361.555Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.936 402.263L110.165 369.452L87.085 362.307L97.7998 370.938L96.4535 377.904L115.766 386.3L140.936 402.263Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5522 363.868L96.4534 377.904L66.3233 382.102L67.9257 375.682L62.8125 372.67L48.0981 369.45L68.5522 363.868Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5762 399.557L41.2562 375.682L66.3233 382.102L41.2562 397.678L36.7303 391.05L11.5762 399.557Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9743 461.212L13.0556 475.789V497.555L4.17773 463.581L18.9743 435.514V461.212Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2562 397.678L11.2572 412.509L0 439.145L11.5761 430.377L18.9744 435.514L28.3745 415.004L41.2562 397.678Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.252 647.055L208.09 627.591L217.204 637.323L199.252 647.055Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 625.853L217.204 637.323L208.09 627.591L229.912 625.853Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.204 654.876L229.912 625.853L217.204 637.323V654.876Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.252 647.055L183.616 659.047H201.131L199.252 647.055Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.084 673.645L183.616 659.047H201.131L189.084 673.645Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 686.157L189.083 673.645L206.542 668.952L189.352 686.157Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.131 659.047L206.542 668.952L189.083 673.645L201.131 659.047Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.204 637.323L199.252 647.055L201.131 659.047L217.204 637.323Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.204 654.876L201.131 659.047L217.204 637.323V654.876Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.542 668.952L217.204 654.876L201.131 659.047L206.542 668.952Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.599 666.346L179.473 677.555L162.414 668.952L174.599 666.346Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.473 688.069V677.555H169.725L179.473 688.069Z",
    fill: "#210D0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 668.952L169.725 677.555H179.473L162.414 668.952Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 686.157L169.725 677.555L179.473 688.069L162.414 686.157Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 668.952V686.157L169.725 677.555L162.414 668.952Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.895 651.226L174.599 666.346L183.616 659.047L165.895 651.226Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.084 673.645L174.599 666.346L183.616 659.047L189.084 673.645Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.473 677.555L189.084 673.645L174.599 666.346L179.473 677.555Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.473 688.069L189.084 673.645L179.473 677.555V688.069Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 686.157L179.473 688.069L189.084 673.645L189.352 686.157Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.616 659.047L174.755 643.232L174.596 655.066L183.616 659.047Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.895 651.226L174.755 643.232L174.596 655.066L165.895 651.226Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 625.853L174.756 643.232L169.69 647.802L162.414 625.853Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.895 651.226L153.013 637.323L169.69 647.802L165.895 651.226Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.132 637.323H153.014L149.619 627.591L140.132 637.323Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 645.665L140.132 637.323L131.778 632.457L133.522 645.665Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.955 656.092L133.522 645.665L126.382 653.051L135.955 656.092Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.658 666.346L135.955 656.092L133.522 666.346H144.658Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.414 668.952L144.658 666.346L153.013 675.904L162.414 668.952Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 686.157V701.624L179.473 688.069L189.352 686.157Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.036 709.966L179.473 688.069L181.841 706.711L177.036 709.966Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.413 686.157L153.013 675.904L162.413 668.952V686.157Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.658 685.115L162.414 686.157L153.013 675.904L144.658 685.115Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.619 627.591L131.778 632.457L140.132 637.323L149.619 627.591Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.169 635.155L153.013 637.323L169.69 647.802L161.169 635.155Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.619 627.591L162.414 625.853L153.014 637.323L149.619 627.591Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.573 619.597L162.414 625.853L149.619 627.591L146.573 619.597Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.778 632.457L146.572 619.597L149.619 627.591L131.778 632.457Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.035 622.204L146.572 619.597L131.778 632.457L130.035 622.204Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.413 625.853L153.013 637.323L161.169 635.155L169.69 647.802L162.413 625.853Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.382 653.051L133.522 666.346L135.955 656.092L126.382 653.051Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.778 632.457L126.382 653.051L133.522 645.665L131.778 632.457Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.035 622.204L119.243 632.457H131.779L130.035 622.204Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 645.665L119.242 632.457L123.768 640.365L115.766 645.665Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.779 632.457H119.243L123.769 640.365L131.779 632.457Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 645.665V658.004L123.768 640.365L115.766 645.665Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.382 653.051L123.769 640.365L131.778 632.457L126.382 653.051Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 658.004L126.382 653.051L123.768 640.365L115.766 658.004Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.768 669.821L115.766 658.004L126.382 653.051L123.768 669.821Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 666.346L123.769 669.821L126.382 653.051L133.522 666.346Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.658 685.115L132.82 679.032L144.658 674.861V685.115Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.013 675.904L144.658 666.346V674.861V685.115L153.013 675.904Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.522 666.346L144.658 674.861V666.346H133.522Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.82 679.032L133.522 666.346L144.658 674.861L132.82 679.032Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.769 669.821L132.821 679.032L133.522 666.346L123.769 669.821Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.572 619.597L138.739 612.298L130.035 612.993L135.955 616.816L130.035 622.204L146.572 619.597Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.035 622.204L121.225 619.333L114.308 624.652L121.359 624.636L119.337 632.374L130.035 622.204Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.243 632.457L110.974 633.504L108.561 639.656L113.135 636.897L115.742 645.745L119.243 632.457Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 645.665L108.561 650.424L108.885 657.022L111.924 652.635L115.766 658.004V645.665Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.968 588.402L108.561 589.402L106.799 579.974L128.351 586.925L147.968 588.402Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4717 567.114L108.561 589.402L106.799 579.974L85.4717 567.114Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3232 552.168L74.4178 572.762L85.4717 567.114L66.3232 552.168Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.561 589.402L74.418 572.762L85.4718 567.114L108.561 589.402Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9743 461.212L13.0557 475.789L29.767 505.419L21.7595 483.826L18.9743 461.212Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4178 572.762L45.6082 546.911L66.3233 552.168L74.4178 572.762Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6119 533.746L45.6082 546.911L66.3233 552.168L49.6119 533.746Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7671 505.419L45.6081 546.911L49.6118 533.746L29.7671 505.419Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0557 475.789L26.8077 519.192L29.767 505.419L13.0557 475.789Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7672 505.419L26.8079 519.192L45.6081 546.911L29.7672 505.419Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.093 104.503L179.827 126.698L194.903 124.691L196.093 104.503Z",
    fill: "#7C1227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.473 102.501L196.093 104.503L179.827 126.698L189.473 102.501Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.473 102.501L159.217 129.441L179.827 126.698L189.473 102.501Z",
    fill: "#690C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.292 87.592L169.927 104.503L175.736 92.9774L162.292 87.592Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.282 307.425L112.747 301.22L98.6386 290.272L90.8679 283.841L89.814 263.238L100.506 285.773L124.282 307.425Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0114 221.48L68.7603 241.586L73.5318 261.028L75.2929 246.005L82.4635 260.69L80.7405 241.586L73.0114 221.48Z",
    fill: "#C52126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.488 325.907L353.115 342.255L342.932 331.524L342.488 325.907Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.636 265.268L180.963 262.714L195.931 261.028L190.428 263.359L193.921 265.944L165.264 270.328L167.636 265.268Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.656 246.005L142.356 247.528L147.552 256.168L137.104 250.423L136.656 246.005Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.081 264.533L259.278 257.6L274.08 261.028L259.278 263.238L263.321 266.265L262.216 268.304L247.537 268.896L239.081 264.533Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.777 349.182L284.122 361.555L292.974 363.764L286.777 349.182Z",
    fill: "#967546"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.589 382.102L279.363 404.417L281.65 391.271L278.589 382.102Z",
    fill: "#F3D7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.455 268.399L208.877 266.006L221.404 264.131L206.758 272.899L206.455 268.399Z",
    fill: "#E82828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.036 709.966L181.841 706.711L174.755 724.04L177.036 709.966Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.752 464.954L329.56 496.382L315.558 514.239L320.651 495.046L313.327 492.478L315.558 488.823L334.752 464.954Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.75 500.358L165.895 516.889L182.389 524.362L150.75 500.358Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.853 475.789L165.155 454.128L177.036 482.827L166.853 475.789Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7999 370.938L89.5865 370.504L81.6602 370.724L96.4535 377.904L97.7999 370.938Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9257 375.682L53.6592 378.859L66.3233 382.102L67.9257 375.682Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7301 391.05L26.604 406.619L41.2561 397.678L36.7301 391.05Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5762 430.377V449.548L18.9744 435.514L11.5762 430.377Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7947 433.747L62.7032 462.966L62.4933 495.046L56.5747 459.421L75.7947 433.747Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6034 478.265L75.795 515.846L62.4937 495.046L62.6034 478.265Z",
    fill: "#401211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6035 478.265L66.512 489.4L74.7381 489.243L62.6035 478.265Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8541 498.922L66.5117 489.4L74.7378 489.243L69.8541 498.922Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3251 503.823L74.7377 489.243L69.854 498.922L77.3251 503.823Z",
    fill: "#401211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1955 503.823L75.7949 515.847L88.0677 512.61L81.1369 507.008L77.1955 503.823Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0675 503.051L77.1953 503.823L88.0675 512.61L96.1224 505.702L88.0675 503.051Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1228 505.702L105.418 517.259L88.0679 512.61L96.1228 505.702Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0676 512.61L81.0132 518.761L89.1707 522.701L88.0676 512.61Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3086 517.396L88.0679 512.61L89.171 522.701L96.6318 522.342L93.3086 517.396Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6317 522.342L96.7876 532.767L89.1709 522.701L96.6317 522.342Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7949 515.839L81.0133 518.761L88.0677 512.61L75.7949 515.839Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7948 515.847L69.854 498.922L77.3251 503.823L75.7948 515.847Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7036 462.966L74.7381 489.243L62.6035 478.265L62.7036 462.966Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1708 522.701L89.6338 531.367L75.7949 515.846L89.1708 522.701Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5912 469.272L62.7031 462.965L67.9254 450.814L65.5912 469.272Z",
    fill: "#401211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2686 445.732L89.1708 438.749L75.7948 433.747L70.2686 445.732Z",
    fill: "#210D0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4307 489.596L18.9744 520.539L32.0301 546.911L28.3745 527.23L31.5373 526.165L26.8078 519.192L17.4307 489.596Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0657 531.367L42.5618 552.863L55.9657 565.723L49.6119 552.863L55.7907 556.048L45.6082 546.911L35.0657 531.367Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.766 658.004L113.921 661.804L117.575 668.952L116.863 663.478L118.414 661.914L115.766 658.004Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.087 665.651L119.243 669.451L122.897 676.599L122.185 671.125L123.769 669.821L121.087 665.651Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.083 558.077H203.255L212.925 564.847L203.396 565.251L206.549 572.762L189.083 558.077Z",
    fill: "#F4816B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.549 572.762L218.046 571.683L226.059 582.516L217.866 578.857L218.227 582.58L206.549 572.762Z",
    fill: "#EA3834"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.249 582.581L228.883 589.399L233.221 601.781L228.201 596.223L229.912 603.956L218.249 582.581Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 603.956L236.479 612.906L235.917 624.507L233.828 616.556L229.912 625.853V603.956Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.912 625.853L231.891 632.073L230.401 640.713L229.358 635.183L224.759 637.623L229.912 625.853Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36 636.8L227.073 642.39L222.669 651.832L222.745 644.852L220.416 642.935L224.36 636.8Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.108 694.428L181.841 706.711L189.352 701.624L184.108 694.428Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.352 701.624L187.97 717.143L181.841 706.711L189.352 701.624Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.597 725.397L181.841 706.711L187.97 717.143L185.597 725.397Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.755 724.04L173.699 735.461L179.439 725.849L174.755 724.04Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.841 706.711L179.439 725.85L174.755 724.04L181.841 706.711Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.596 725.397L179.438 725.85L181.841 706.711L185.596 725.397Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.596 725.397L179.439 725.849L178.295 733.862L185.596 725.397Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.596 725.397L183.346 740.854L178.295 733.862L185.596 725.397Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.439 725.849L178.295 733.862L173.699 735.461L179.439 725.849Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.295 733.862L173.699 735.461L174.755 748.853L178.295 733.862Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.346 740.854L178.295 733.862L179.439 744.127L186.381 751.277L183.346 740.854Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.755 748.853L178.295 733.862L179.439 744.127L174.755 748.853Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.161 762.79L179.439 744.127L174.755 748.853L181.161 762.79Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.381 751.277L179.438 744.127L180.245 752.87L186.381 751.277Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33 761.457L186.381 751.277L180.246 752.87L192.33 761.457Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.97 764.972L180.246 752.87L192.33 761.457L187.97 764.972Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.161 762.79L180.246 752.87L187.97 764.972L181.161 762.79Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.301 775.031L181.161 762.79L187.97 764.972L193.301 775.031Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.33 761.457L200.828 768.911L187.97 764.972L192.33 761.457Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.186 772.244L200.828 768.911L187.97 764.972L197.186 772.244Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.301 775.031L197.186 772.244L187.97 764.972L193.301 775.031Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.689 780L193.301 775.031L197.185 772.244L209.689 780Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.827 768.911L200.555 769.16L197.186 772.244L211.874 770.002L200.827 768.911Z",
    fill: "#E41E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.689 774.425L211.874 770.002L197.186 772.244L209.689 774.425Z",
    fill: "#A31E21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.679 775.031L209.689 774.425L197.186 772.244L201.679 775.031Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.689 780L223.164 778.909L209.689 774.425V780Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.679 775.031L209.689 774.425V780L201.679 775.031Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.473 688.069L184.108 694.428L181.841 706.711L179.473 688.069Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.733 769.778L226.933 767.019L223.695 773.938L221.733 769.778Z",
    fill: "#BD2E28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.695 773.938L226.785 775.677L223.165 778.909L223.695 773.938Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.695 773.938L227.901 769.324L226.785 775.677L223.695 773.938Z",
    fill: "#771213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.695 773.938L226.933 767.019L227.901 769.324L223.695 773.938Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.933 767.019L230.795 766.304L227.901 769.324L226.933 767.019Z",
    fill: "#D42E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.933 767.019L229.769 764.481L230.795 766.304L226.933 767.019Z",
    fill: "#C32E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.768 764.481L227.463 762.792L228.049 766.042L229.768 764.481Z",
    fill: "#63202A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.463 762.792C227.463 762.792 226.202 759.423 226.268 759.332C226.334 759.24 229.844 760.703 229.844 760.703L227.463 762.792Z",
    fill: "#65222B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.268 759.332L227.711 755.032L229.844 760.703L226.268 759.332Z",
    fill: "#721614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.844 760.703L229.768 764.481L227.463 762.792L229.844 760.703Z",
    fill: "#721614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.769 764.481L234.176 750.878L229.981 753.727L229.769 764.481Z",
    fill: "#D22E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.769 764.481L231.744 763.571L230.795 766.304L229.769 764.481Z",
    fill: "#D22E2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.901 769.324L231.003 770.129L226.785 775.677L227.901 769.324Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.901 769.324L230.795 766.304L231.003 770.129L227.901 769.324Z",
    fill: "#C72A34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.002 770.129L235.352 763.148L230.794 766.304L231.002 770.129Z",
    fill: "#E02B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.794 766.304L231.744 763.571L235.352 763.148L230.794 766.304Z",
    fill: "#C32E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.744 763.571L234.176 750.878L229.769 764.481L231.744 763.571Z",
    fill: "#C32E32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.744 763.571L235.352 763.148L233.243 755.586L231.744 763.571Z",
    fill: "#CA312A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.352 763.148L239.167 759.503L233.243 755.586L235.352 763.148Z",
    fill: "#B72D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.352 763.148L240.248 765.283L239.167 759.503L235.352 763.148Z",
    fill: "#DD2F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.248 765.283L231.002 770.129L235.351 763.148L240.248 765.283Z",
    fill: "#B7272E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.002 770.129C231.002 770.129 234.025 772.538 234.161 772.461C234.296 772.384 234.519 768.286 234.519 768.286L231.002 770.129Z",
    fill: "#662625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.519 768.286L236.708 773.082L234.161 772.461L234.519 768.286Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.519 768.286L237.906 770.723L236.707 773.082L234.519 768.286Z",
    fill: "#781514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.906 770.723L242.916 773.763L236.708 773.082L237.906 770.723Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.906 770.723L240.248 765.283L234.519 768.286L237.906 770.723Z",
    fill: "#A62E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.906 770.723L244.678 770.687L240.248 765.283L237.906 770.723Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.906 770.723L240.8 772.479L244.678 770.687L237.906 770.723Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.248 765.283L244.75 760.872L239.167 759.503L240.248 765.283Z",
    fill: "#A53027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.248 765.283L244.679 770.687L246.209 764.508L240.248 765.283Z",
    fill: "#761915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75 760.872L248.371 755.415L239.167 759.503L244.75 760.872Z",
    fill: "#E9282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.167 759.503L245.494 747.928L248.371 755.415L239.167 759.503Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75 760.872L248.724 758.546L248.371 755.415L244.75 760.872Z",
    fill: "#95312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75 760.872L240.248 765.283L246.209 764.508L244.75 760.872Z",
    fill: "#78211F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.209 764.508C246.209 764.508 251.68 771.871 251.476 771.755C251.271 771.64 244.679 770.687 244.679 770.687L246.209 764.508Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.209 764.508L248.724 758.546L244.75 760.872L246.209 764.508Z",
    fill: "#80171B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.209 764.508L251.076 765.274L248.724 758.546L246.209 764.508Z",
    fill: "#7D1C17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.209 764.508L251.076 765.274L251.476 771.755L246.209 764.508Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.475 771.755L256.777 767.826L251.075 765.274L251.475 771.755Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.076 765.274L251.439 758.994L248.724 758.546L251.076 765.274Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.075 765.274L255.12 763.963L251.438 758.994L251.075 765.274Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.12 763.963L256.358 758.302L251.438 758.994L255.12 763.963Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.121 763.963L261.291 760.581L256.358 758.302L255.121 763.963Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.438 758.994L253.275 754.863L256.358 758.302L251.438 758.994Z",
    fill: "#781219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.358 758.302L256.452 754.867L253.275 754.863L256.358 758.302Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.358 758.302L260.047 757.35L256.452 754.867L256.358 758.302Z",
    fill: "#5A0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.439 758.994L248.371 755.415L248.724 758.546L251.439 758.994Z",
    fill: "#5A0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.371 755.415L253.276 754.863L251.439 758.994L248.371 755.415Z",
    fill: "#781219"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.371 755.415L245.495 747.928L252.614 752.755L248.371 755.415Z",
    fill: "#EE333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.614 752.755L262.715 752.973L258.548 749.911L252.614 752.755Z",
    fill: "#E02D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.614 752.755L245.495 747.928L255.236 747.945L252.614 752.755Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.614 752.755L258.548 749.911L255.236 747.945L252.614 752.755Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.548 749.911L262.855 747.488L255.235 747.945L258.548 749.911Z",
    fill: "#E9282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.548 749.911L262.715 752.973L262.855 747.488L258.548 749.911Z",
    fill: "#EE333F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.715 752.973L272.686 756.796L262.855 747.488L262.715 752.973Z",
    fill: "#E9282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.495 747.928L254.93 745.578L255.236 747.945L245.495 747.928Z",
    fill: "#B72D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.495 747.928L250.426 743.315L254.93 745.578L245.495 747.928Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.93 745.578L260.75 742.582L250.425 743.315L254.93 745.578Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.495 747.928L245.862 743.748L250.426 743.315L245.495 747.928Z",
    fill: "#DD2F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.167 759.503C239.167 759.503 236.148 757.507 236.091 757.469C236.033 757.431 245.495 747.928 245.495 747.928L239.167 759.503Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09 757.469L236.955 753.134L245.494 747.928L236.09 757.469Z",
    fill: "#E9282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.955 753.134L241.421 745.096L245.494 747.928L236.955 753.134Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.421 745.096L245.862 743.748L245.495 747.928L241.421 745.096Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.421 745.096L244.166 736.475L245.862 743.748L241.421 745.096Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.862 743.748L247.43 740.039L244.167 736.475L245.862 743.748Z",
    fill: "#B72D2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.862 743.748L250.743 739.376L247.43 740.039L245.862 743.748Z",
    fill: "#A53027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.743 739.376L250.425 743.315L245.862 743.748L250.743 739.376Z",
    fill: "#D82E27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.425 743.315L256.033 740.385L250.743 739.376L250.425 743.315Z",
    fill: "#EF3F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.955 753.134L237.184 748.973L241.421 745.096L236.955 753.134Z",
    fill: "#5A1C17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.185 748.973L238.382 745.271L241.421 745.096L237.185 748.973Z",
    fill: "#721614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.381 745.271L240.64 742.302L240.349 745.157L238.381 745.271Z",
    fill: "#63202A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.875 770.002L221.733 769.778L223.695 773.938L211.875 770.002Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.689 774.425L211.875 770.002L223.695 773.938L209.689 774.425Z",
    fill: "#D02027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.164 778.909L223.695 773.938L209.689 774.425L223.164 778.909Z",
    fill: "#60100C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.469 382.987L366.375 393.26L368.434 413.848L362.337 427.395L360.736 413.255L357.206 416.127L359.469 382.987Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.205 416.127L359.468 435.467L354.189 451.808L354.658 439.135L348.395 439.845L349.265 437.73L357.205 416.127Z",
    fill: "#ED4A42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.146 303.586L124.283 307.425H108.1L117.146 303.586Z",
    fill: "#311218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.496 31.9412L192.273 47.9487L197.762 46.6866L192.452 34.1858L188.496 31.9412Z",
    fill: "#A8968C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.273 47.9487L165.006 27.4689L186.417 47.6697L192.273 47.9487Z",
    fill: "#916362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.273 47.9487L190.239 39.6631L159.181 11.3942L165.006 27.4689L192.273 47.9487Z",
    fill: "#FFEFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.181 11.3942L165.006 27.4689V45.6574L159.518 35.339L159.181 11.3942Z",
    fill: "#898084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.006 27.4689L186.417 47.6697L165.006 45.6574V27.4689Z",
    fill: "#895B59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 45.6574L186.417 47.6697L178.534 51.2245L163.575 45.6574Z",
    fill: "#F04D4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.181 11.3942L164.487 10.4474L174.996 25.7892L159.181 11.3942Z",
    fill: "#FEEECF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.244 0L164.487 10.4474L159.181 11.3942L147.244 0Z",
    fill: "#FEF6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.096 13.3857L159.18 11.3942L159.518 35.339L157.096 13.3857Z",
    fill: "#92878C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.096 13.3857L159.181 11.3942L147.244 0L157.096 13.3857Z",
    fill: "#776F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.944 66.8972L268.921 77.506L268.064 75.3587L271.944 66.8972Z",
    fill: "#640A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.466 67.2157L187.935 68.0749L195.273 71.4432L195.466 67.2157Z",
    fill: "#200F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.318 129.211L194.205 147.364L199.751 128.861L203.879 129.211H212.318Z",
    fill: "#10131F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.89 121.569L252.961 115.351H251.274H249.587L260.89 123.036V121.569Z",
    fill: "#C5BEB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.72 109.962L251.274 115.351H249.588L227.449 103.307L228.865 99.716L234.405 105.377H237.273C237.273 105.377 237.104 107.099 238.116 107.436C239.129 107.773 243.008 109.12 243.008 109.12L244.695 110.636L246.72 109.962Z",
    fill: "#898381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.63 121.462L238.383 108.192L248.159 118.599L252.882 123.905L254.063 125.776L256.256 125.016L259.63 121.462Z",
    fill: "#B22827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.465 121.462L228.77 115.904L230.813 104.62H232.113L246.214 123.314L241.465 121.462Z",
    fill: "#3F131D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.937 94.4946L192.954 103.947L204.921 110.237L228.77 115.904L230.813 104.62L218.502 95.6945L201.937 94.4946Z",
    fill: "#180F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.083 50.5193L192.452 34.1858L203.267 48.4726L214.083 50.5193Z",
    fill: "#F04F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.267 48.4726L192.451 34.1858L192.272 47.9487L203.267 48.4726Z",
    fill: "#981B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.417 47.6697L201.093 53.0863L189.453 51.8447L186.417 47.6697Z",
    fill: "#F79233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.093 57.9702L189.454 51.8447L201.093 53.0863V57.9702Z",
    fill: "#F79233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.441 58.5597L201.093 53.0863V57.9702L214.441 58.5597Z",
    fill: "#FCB457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.441 58.5597L201.093 57.9702L209.697 63.191L214.441 58.5597Z",
    fill: "#FEC971"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.441 58.5597L209.697 63.191L217.161 68.0749L214.441 58.5597Z",
    fill: "#EF3B24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.417 47.6697L203.267 48.4726L214.441 58.5597L201.093 53.0863L186.417 47.6697Z",
    fill: "#F0524C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.161 68.0749L213.324 72.9589L209.697 63.191L217.161 68.0749Z",
    fill: "#8F191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.093 57.9702L209.697 63.191L207.588 66.2224L201.093 57.9702Z",
    fill: "#8F191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.323 72.9589L207.588 66.2224L209.697 63.191L213.323 72.9589Z",
    fill: "#600811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 51.8447L201.093 57.9702L203.148 60.5806H190.128L189.454 51.8447Z",
    fill: "#911A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.453 63.191L199.155 64.836L187.935 68.0749L189.453 63.191Z",
    fill: "#57101F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.162 68.0749L213.324 72.9589L233.989 75.3587L217.162 68.0749Z",
    fill: "#9E1D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.935 68.0749L207.588 66.2224L201.937 64.033L187.935 68.0749Z",
    fill: "#2E1215"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.334 65.633L217.161 68.0749L240.378 68.917L216.334 65.633Z",
    fill: "#F37456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.947 72.1539L217.161 68.0749L240.378 68.917L225.947 72.1539Z",
    fill: "#F37760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.378 68.917L233.988 75.3587L225.947 72.1539L240.378 68.917Z",
    fill: "#F05248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.378 68.917L228.864 65.1277L216.334 65.633L240.378 68.917Z",
    fill: "#F16252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.441 58.5597L216.335 65.633L229.181 65.1277L214.441 58.5597Z",
    fill: "#F04F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.378 68.917L241.327 67.7802H236.924L240.378 68.917Z",
    fill: "#F05248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.864 65.1277L236.924 67.7802H240.757L238.492 67.275L228.864 65.1277Z",
    fill: "#F9A479"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.572 64.033L238.226 67.2157L228.864 65.1277L230.572 64.033Z",
    fill: "#F9A46F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.267 48.4726L214.083 50.5193L214.441 58.5597L203.267 48.4726Z",
    fill: "#EF4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.083 50.5193L214.441 58.5597H221.811L214.083 50.5193Z",
    fill: "#EF423B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.865 65.1277L214.441 58.5597H221.811L228.865 65.1277Z",
    fill: "#EE342D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.417 47.6697L190.128 60.5806L189.453 51.8447L186.417 47.6697Z",
    fill: "#8E191C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.588 66.2224L203.148 60.5806L201.937 64.033L207.588 66.2224Z",
    fill: "#710F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.148 60.5806L189.454 63.191L199.155 64.836L203.148 60.5806Z",
    fill: "#721011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.298 72.3905L203.148 75.3587H206.091L209.697 71.7168L207.588 66.2224L197.298 67.1924V72.3905Z",
    fill: "#F79233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.937 64.033L203.148 60.5806L199.155 64.836L201.937 64.033Z",
    fill: "#710F11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 63.191L190.128 60.5806H203.148L189.454 63.191Z",
    fill: "#630F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.879 67.0224L206.597 68.0749L207.588 66.2224L203.879 67.0224Z",
    fill: "#600811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.128 60.5806L189.453 63.191L181.672 60.5806H190.128Z",
    fill: "#721011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.453 63.191L187.935 68.0749L181.672 60.5806L189.453 63.191Z",
    fill: "#630F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.588 66.2224L200.429 66.8972C200.429 66.8972 198.695 73.1483 204.193 72.9589C201.336 69.5625 202.485 68.3486 202.485 68.3486L207.588 66.2224Z",
    fill: "#801517"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.787 67.7802C206.787 67.7802 204.573 66.3908 202.169 68.3486C201.6 69.4854 201.094 72.1379 204.478 72.9589C205.712 72.9868 207.926 72.4115 207.356 69.5906C207.166 68.4749 206.787 67.7802 206.787 67.7802Z",
    fill: "#21100F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 68.3486C203.497 68.3486 205.964 67.0224 206.344 69.4132C206.344 70.1444 203.497 70.4959 203.497 68.3486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.273 67.3832C195.273 67.3832 192.87 67.7802 195.273 71.4432L197.298 72.3905C197.298 72.3905 197.089 67.634 198.373 67.302C196.331 67.6599 195.273 67.3832 195.273 67.3832Z",
    fill: "#630C22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17 68.6644L195.273 67.3832L200.429 66.8972L200.17 68.6644Z",
    fill: "#3E1315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.323 72.9589L208.994 72.1731L207.588 66.2224L213.323 72.9589Z",
    fill: "#2F1211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.588 66.2224L206.597 68.0749L208.995 72.1731L207.588 66.2224Z",
    fill: "#9E1D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 77.506V92.4947L254.738 89.1264L243.604 77.506Z",
    fill: "#9E1D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.197 88.2844L254.738 89.1264L257.943 79.0354L265.197 83.232V88.2844Z",
    fill: "#EF4024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 77.506L257.943 79.0354L254.738 89.1264L243.604 77.506Z",
    fill: "#F15A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.724 75.3587L254.738 76.8324L257.943 79.0354L243.604 77.506L239.724 75.3587Z",
    fill: "#F9A246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.065 75.3587L265.197 83.232V88.2844L272.645 89.1264L268.065 75.3587Z",
    fill: "#EF4225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.967 75.3587H268.065L265.197 83.232L259.967 75.3587Z",
    fill: "#BE2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.292 65.9274C247.123 66.4327 245.272 75.8346 245.272 75.8346L254.738 76.8324L257.943 79.0354L254.063 72.9631L247.292 65.9274Z",
    fill: "#640A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 62.0963L247.291 65.9274L245.272 75.8346L239.724 75.3587L243.604 62.0963Z",
    fill: "#941A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.943 70.1309L243.604 62.0963L254.063 72.9631L259.967 75.3587L257.943 70.1309Z",
    fill: "#F15737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.197 83.232L259.967 75.3587L254.063 72.9631L257.943 79.0354L265.197 83.232Z",
    fill: "#A31E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.943 70.1309L268.064 75.3587H259.967L257.943 70.1309Z",
    fill: "#F1573B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.004 62.7083L268.064 75.3588L257.943 70.1309L263.004 62.7083Z",
    fill: "#F37760"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.945 66.8972L268.065 75.3588L263.004 62.7083L271.945 66.8972Z",
    fill: "#F26340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.064 90.4737L272.645 89.1264L265.197 88.2844L254.738 89.1264L243.604 92.4947L225.947 97.3786L230.813 97.4267L250.773 91.3158L257.099 89.8001L266.377 89.1264L268.064 90.4737Z",
    fill: "#4C1A1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 95.8629L208.854 87.2739L213.323 95.8629H203.497Z",
    fill: "#660916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.947 97.3786L213.324 95.8629L221.811 90.1369L225.947 97.3786Z",
    fill: "#701123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.854 87.2739L221.811 90.1369L213.323 95.8629L208.854 87.2739Z",
    fill: "#79121F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.181 90.1369H221.811L225.947 97.3786L229.181 90.1369Z",
    fill: "#720E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.724 75.3587L243.604 77.506L229.181 90.1369L239.724 75.3587Z",
    fill: "#7E141E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 92.4947L235.046 85.0003L243.604 77.506V92.4947Z",
    fill: "#6E0F1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.046 85.0003L233.163 95.4429L243.604 92.4947L235.046 85.0003Z",
    fill: "#6B101F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.947 97.3786L229.181 90.1369L233.162 95.4429L225.947 97.3786Z",
    fill: "#6A1022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.046 85.0003L229.181 90.1369L233.162 95.4429L235.046 85.0003Z",
    fill: "#6F0F1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.988 75.3587L241.326 67.7802L239.724 75.3587H233.988Z",
    fill: "#7C1318"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.181 90.1369L233.988 75.3587H239.724L229.181 90.1369Z",
    fill: "#911A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.635 83.3162L232.113 80.9645L229.181 90.1369L219.635 83.3162Z",
    fill: "#EF3829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.854 87.2739L219.635 83.3162L221.811 90.1369L208.854 87.2739Z",
    fill: "#BD4148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.181 90.1369H221.811L219.635 83.3162L229.181 90.1369Z",
    fill: "#C12126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 95.8629L194.205 99.3996L208.854 87.2739L203.497 95.8629Z",
    fill: "#3F131D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.128 90.2216L197.298 89.0931L208.854 87.2739L194.205 99.3996L190.128 90.2216Z",
    fill: "#6B0C11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.549 80.9645L190.128 90.2216L197.298 89.0931L183.549 80.9645Z",
    fill: "#E52525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.801 72.6289L187.935 68.0749L183.549 80.9645L176.801 72.6289Z",
    fill: "#81151F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.682 89.1264L190.128 90.2216L183.549 80.9645L180.682 89.1264Z",
    fill: "#F47945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 93.7578L180.682 89.1264L190.128 90.2216L189.454 93.7578Z",
    fill: "#C62127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.205 99.3996L189.454 93.7578L190.128 90.2216L194.205 99.3996Z",
    fill: "#9F1D20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.453 103.947L194.205 99.3996L189.453 93.7578L174.608 101.757L189.453 103.947Z",
    fill: "#EE3224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.681 89.1264L189.453 93.7578L174.608 101.757L180.681 89.1264Z",
    fill: "#88181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.549 80.9645H170.054L176.801 72.6289L183.549 80.9645Z",
    fill: "#EB2425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 86.7266L180.682 89.1264L166.005 102.263V86.7266Z",
    fill: "#7D131E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.609 101.757L166.005 102.263L180.682 89.1264L174.609 101.757Z",
    fill: "#901A1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.054 80.9645L166.005 86.7266L180.682 89.1264L170.054 80.9645Z",
    fill: "#EF3A43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.549 80.9645L180.681 89.1264L170.054 80.9645H183.549Z",
    fill: "#EF4643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 86.7266L170.054 80.9645L157.096 80.0322L166.005 86.7266Z",
    fill: "#F2695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.654 85.5931L166.005 86.7266L157.097 80.0322L150.654 85.5931Z",
    fill: "#F5876F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.047 89.9766L157.097 80.0322L150.654 85.5931L114.047 89.9766Z",
    fill: "#F2695A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 86.7266L159.865 92.4654L114.047 89.9766L150.654 85.5931L166.005 86.7266Z",
    fill: "#B92025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 102.263V86.7266L159.865 92.4654L166.005 102.263Z",
    fill: "#5E0813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.813 115.009L161.994 95.8629L157.096 108.662L121.813 115.009Z",
    fill: "#EF3E37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.005 102.263L157.096 108.662L161.994 95.8629L166.005 102.263Z",
    fill: "#951B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.865 92.4654L161.994 95.8629L121.813 115.009L159.865 92.4654Z",
    fill: "#15172B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.096 80.0322L167.186 74.1378L170.054 80.9645L157.096 80.0322Z",
    fill: "#DF282B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.802 72.6289L167.186 74.1378L170.054 80.9645L176.802 72.6289Z",
    fill: "#A51E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 57.9702L167.186 74.1378L176.802 72.6289L163.575 57.9702Z",
    fill: "#700F23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.673 60.5806L176.802 72.6289L163.575 57.9702L181.673 60.5806Z",
    fill: "#81151E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.935 68.0749L176.801 72.6289L181.672 60.5806L187.935 68.0749Z",
    fill: "#8A1A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.273 71.4432L187.935 68.0749L185.457 75.3587L195.273 71.4432Z",
    fill: "#6E1124"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.602 75.8346L185.457 75.3587L195.273 71.4432L204.602 75.8346Z",
    fill: "#A61E22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.324 72.9589L206.091 75.3587L209.341 70.7906L213.324 72.9589Z",
    fill: "#EB4828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.887 79.971L207.448 82.7478L208.854 87.2739L197.298 89.0931L183.549 80.9645L183.887 79.971Z",
    fill: "#EF472E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.635 83.3162L213.323 72.9589L207.448 82.7478L208.854 87.2739L219.635 83.3162Z",
    fill: "#EF3C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.091 75.3587L207.448 82.7478L213.324 72.9589L206.091 75.3587Z",
    fill: "#EF4330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.887 79.971L185.457 75.3587H206.091L183.887 79.971Z",
    fill: "#ED2224"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.448 82.7478L206.091 75.3587L183.887 79.971L207.448 82.7478Z",
    fill: "#EF3925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.324 72.9589L233.989 75.3587L219.635 83.3162L213.324 72.9589Z",
    fill: "#F04B34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.113 80.9645L219.635 83.3162L233.988 75.3587L232.113 80.9645Z",
    fill: "#EE2525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.417 47.6697L181.672 60.5806H190.128L186.417 47.6697Z",
    fill: "#971D23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 57.9702L186.417 47.6697L181.673 60.5806L163.575 57.9702Z",
    fill: "#EF4643"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.751 122.611L157.096 108.662L166.005 102.263L164.487 115.009L137.751 122.611Z",
    fill: "#EF433F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.621 112.463L164.487 115.036L166.005 102.289L182.621 112.463Z",
    fill: "#EC2130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.609 101.757L166.005 102.263L182.622 112.437L174.609 101.757Z",
    fill: "#851619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.453 103.947L182.621 112.437L174.608 101.757L189.453 103.947Z",
    fill: "#700E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.016 129.211L182.622 112.437L190.128 114.893L159.016 129.211Z",
    fill: "#EF403E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.879 129.211L194.205 118.599L190.423 128.03L203.879 129.211Z",
    fill: "#CA2327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.128 114.893L190.424 128.03L194.205 118.599L190.128 114.893Z",
    fill: "#DE2D27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.016 129.211L190.424 128.03L190.128 114.893L159.016 129.211Z",
    fill: "#EE2D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.205 118.599L211.384 120.824L203.879 129.211L194.205 118.599Z",
    fill: "#DA2727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.089 126.682L254.063 129.211L252.882 123.905C252.882 123.905 254.232 120.692 254.063 120.824C253.895 120.956 256.256 125.016 256.256 125.016L259.63 121.462L263.004 125.016L270.089 126.682Z",
    fill: "#FCE7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.016 112.437V118.599L263.004 125.016L259.63 121.462L264.016 112.437Z",
    fill: "#94715F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.474 126.067L266.546 118.726L264.016 112.437V118.599L263.004 125.016L267.474 126.067Z",
    fill: "#D1B9A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.159 118.599L252.882 123.905L254.063 129.211L243.604 125.016L248.159 118.599Z",
    fill: "#B79686"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.757 116.914L245.272 122.666L243.015 126.067L237.658 123.314L240.757 116.914Z",
    fill: "#CCC4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.392 115.009L239.125 120.284L237.658 123.314L223.288 116.327L228.77 115.904L230.446 113.378L236.392 119.252V115.009Z",
    fill: "#877F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.27 128.148L186.417 145.544L199.855 128.858L190.423 128.03L187.27 128.148Z",
    fill: "#10131F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 103.947L190.128 114.893L182.622 112.437L189.454 103.947Z",
    fill: "#80181A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.205 118.599L197.86 110.515L189.454 103.947L190.128 114.893L194.205 118.599Z",
    fill: "#BE2026"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.384 120.824L197.859 110.515L194.205 118.599L211.384 120.824Z",
    fill: "#7E1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.089 126.682L268.921 129.211L256.087 133.082L254.063 129.211L270.089 126.682Z",
    fill: "#EF3926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 122.611L243.604 125.016L254.063 129.211L256.087 133.082L242.795 129.211L236.34 122.611Z",
    fill: "#EF423B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.921 129.211L257.943 144.702L256.087 133.082L268.921 129.211Z",
    fill: "#BA2025"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.984 140.787L257.943 144.702L268.921 129.211L265.984 140.787Z",
    fill: "#AC1F24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.967 154.807L265.984 140.787L257.943 144.702L259.967 154.807Z",
    fill: "#E42A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.795 129.211L256.088 133.082L257.943 144.702L242.795 129.211Z",
    fill: "#610D16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.967 154.807L252.882 146.532L257.943 144.702L259.967 154.807Z",
    fill: "#590F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 122.611L257.943 144.702L252.882 146.532L236.34 122.611Z",
    fill: "#5D0B16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.774 154.807L252.882 146.532L236.34 122.611L243.351 143.187L249.774 154.807Z",
    fill: "#4F131A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.384 120.824L228.356 131.903L212.058 129.211H203.879L211.384 120.824Z",
    fill: "#5D0C15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.351 143.187L228.356 131.903L239.908 133.082L243.351 143.187Z",
    fill: "#5C0D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.384 120.824L239.908 133.082L228.356 131.903L211.384 120.824Z",
    fill: "#4E1316"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 122.611L211.384 120.824L239.908 133.082L236.34 122.611Z",
    fill: "#680F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.859 110.515L217.161 113.378L211.384 120.824L197.859 110.515Z",
    fill: "#680F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34 122.611L211.384 120.824L217.162 113.378L236.34 122.611Z",
    fill: "#7E1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.454 103.947L195.274 102.263L197.86 110.515L189.454 103.947Z",
    fill: "#C39F8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.77 115.904L226.812 113.378L223.656 111.862V116.504L228.77 115.904Z",
    fill: "#656572"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.662 109.42L218.502 111.862L217.161 113.378L223.656 116.504V113.378L220.662 109.42Z",
    fill: "#666876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.816 112.437L215.332 107.097L218.502 111.862L217.161 113.378L210.816 112.437Z",
    fill: "#5F5F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.273 102.263L205.395 111.862L197.859 110.515L195.273 102.263Z",
    fill: "#887475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.249 110.743L206.597 103.947L204.921 107.231L201.937 104.62L201.53 108.196L205.395 111.862L210.816 112.437L212.249 110.743Z",
    fill: "#7D6777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.497 95.8629L195.274 102.263L189.454 103.947L194.205 99.3996L203.497 95.8629Z",
    fill: "#47313A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.448 99.9048L203.497 95.8629H213.323L209.707 100.915L208.41 97.3786L207.448 99.9048Z",
    fill: "#503F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.333 99.9048L213.324 95.8629L218.502 96.4847L215.333 99.9048Z",
    fill: "#503F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.811 101.757L217.205 97.8839L218.502 96.4847L225.947 97.3786L221.811 101.757Z",
    fill: "#503F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.064 90.4737L267.474 94.4946H264.016V89.2979L266.377 89.1264L268.064 90.4737Z",
    fill: "#898381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.004 104.62L267.474 94.4946H264.016L263.004 104.62Z",
    fill: "#C5BEB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.642 94.8106L264.016 94.4946L263.004 104.62L260.642 94.8106Z",
    fill: "#FCE5B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1 89.8001L260.642 94.8106L264.016 94.4946V89.2979L257.1 89.8001Z",
    fill: "#6C5957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.773 96.4847L256.425 95.6945L257.099 89.8001L251.607 91.116L250.773 96.4847Z",
    fill: "#7F6C65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.936 103.737L256.425 95.6945L250.773 96.4847L253.936 103.737Z",
    fill: "#745D55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.004 104.62L256.425 95.6945L257.1 89.8001L260.642 94.8106L263.004 104.62Z",
    fill: "#302424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.774 103.737L250.774 96.4847L251.607 91.116L244.172 93.3367L249.774 103.737Z",
    fill: "#7F7373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.254 98.8522L246.9 98.4019L244.172 93.3367L242.254 98.8522Z",
    fill: "#38292F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.125 105.378L242.254 98.8522L244.172 93.3367L235.629 95.8629L239.125 105.378Z",
    fill: "#665255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.545 103.737L236.55 98.3786L235.629 95.8629L230.813 97.4267L233.545 103.737Z",
    fill: "#5B484B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.021 100.217L230.813 97.4267L226.904 97.2102L225.947 97.3786L223.402 100.073L226.812 103.737L232.021 100.217Z",
    fill: "#4F3239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.113 104.62L238.383 108.192L248.159 118.599L245.272 122.666L240.757 116.914L232.113 104.62Z",
    fill: "#580F1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.604 62.0963L241.327 67.7802L239.724 75.3587L243.604 62.0963Z",
    fill: "#640A15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.083 50.5193H224.408L221.811 58.5597L214.083 50.5193Z",
    fill: "#EF3733"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.865 65.1277L221.811 58.5597L224.408 50.5193L228.865 65.1277Z",
    fill: "#F04C37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.813 55.823L228.864 65.1277L227.477 60.5806L230.813 55.823Z",
    fill: "#D72827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.408 50.5193L230.813 55.823L227.478 60.5806L224.408 50.5193Z",
    fill: "#F36E40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.186 74.1378L100.479 89.2979L114.047 89.9766L157.096 80.0322L167.186 74.1378Z",
    fill: "#471319"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.186 74.1378L153.948 56.2127L163.575 57.9702L167.186 74.1378Z",
    fill: "#724E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.186 74.1378L164.487 74.7512L146.59 62.7083L153.948 56.2127L167.186 74.1378Z",
    fill: "#62383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.289 51.2245L153.948 56.2127L146.59 62.7083L136.289 51.2245Z",
    fill: "#744D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.026 42.3526L136.289 51.2245L153.948 56.2127L140.026 42.3526Z",
    fill: "#FEEBC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 45.6574L153.948 56.2127L140.026 42.3526L163.575 45.6574Z",
    fill: "#FDDFBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 57.9702L153.948 56.2127L163.575 45.6574L170.367 54.9075L163.575 57.9702Z",
    fill: "#FFDDB8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.534 51.2245L170.367 54.9075L163.575 45.6574L178.534 51.2245Z",
    fill: "#FDF8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.904 35.339L140.026 42.3526L163.575 45.6574L141.904 35.339Z",
    fill: "#745658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.575 45.6574L142.666 33.1377L141.904 35.339L163.575 45.6574Z",
    fill: "#8F7670"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.666 33.1377L116.177 37.4052L141.904 35.339L142.666 33.1377Z",
    fill: "#A58D89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 37.4052L121.813 39.5857L141.904 35.339L116.177 37.4052Z",
    fill: "#B99E94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.904 35.339L140.026 42.3526L124.189 43.0954L121.813 39.5857L141.904 35.339Z",
    fill: "#74575E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 37.4052L100.479 27.1944L121.813 36.4971L116.177 37.4052Z",
    fill: "#D4B6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.479 27.1944L114.869 39.9448L116.177 37.4052L100.479 27.1944Z",
    fill: "#6F5656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.189 43.0954L114.869 39.9448L116.177 37.4052L121.813 39.5857L124.189 43.0954Z",
    fill: "#664E4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.026 42.3526L86.4932 43.0788L96.3917 46.6866L136.289 51.2245L140.026 42.3526Z",
    fill: "#F7D1AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.59 62.7083L136.289 51.2245L116.177 55.55L146.59 62.7083Z",
    fill: "#673639"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.289 51.2245L96.3916 46.6866L116.177 55.55L136.289 51.2245Z",
    fill: "#603135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.177 55.55L85.2729 47.3415L96.3918 46.6866L116.177 55.55Z",
    fill: "#62383F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2729 47.3415L66.9331 27.2523L91.3213 46.9853L85.2729 47.3415Z",
    fill: "#72575A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3213 43.0133L66.9331 27.2523L86.4932 43.0788L91.3213 43.0133Z",
    fill: "#FEF6E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.487 74.7512L146.59 62.7083L148.714 78.3358L164.487 74.7512Z",
    fill: "#4B1322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.421 73.6389L146.59 62.7083L148.714 78.3358L129.421 73.6389Z",
    fill: "#5D0D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.687 62.6167L129.421 73.6389L146.59 62.7083L132.687 62.6167Z",
    fill: "#7A1129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.686 62.6167L122.67 62.0963L105.385 70.1309L129.421 73.6389L132.686 62.6167Z",
    fill: "#BF2126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6494 60.7445L122.67 62.0963L105.385 70.1309L96.6494 60.7445Z",
    fill: "#E01F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.714 78.3358L131.383 79.971L105.385 70.1309L129.421 73.6389L148.714 78.3358Z",
    fill: "#5B0F14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6496 60.7445L92.6309 69.5906L105.385 70.1309L96.6496 60.7445Z",
    fill: "#771228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6308 69.5906L79.127 68.0749L92.6308 59.4808L96.6495 60.7445L92.6308 69.5906Z",
    fill: "#6A1424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6308 59.4808L64.0161 58.5597L89.9411 61.1927L92.6308 59.4808Z",
    fill: "#DB383E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.127 68.0749L89.9411 61.1927L64.0161 58.5597L55.7681 59.4808L79.127 68.0749Z",
    fill: "#A91E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1433 44.3101L64.0161 58.5597L55.7681 59.4808L40.1433 44.3101Z",
    fill: "#B8202C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1433 44.3101L52.8973 60.4753L55.7681 59.4808L40.1433 44.3101Z",
    fill: "#5B121B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1272 68.0749L55.7682 59.4808L52.8975 60.4753L76.4433 70.5221L79.1272 68.0749Z",
    fill: "#46141B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.383 79.971L105.385 70.1309L87.8882 73.0747L131.383 79.971Z",
    fill: "#50131C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4434 70.5221L79.1273 68.0749L105.385 70.1309L87.8886 73.0747L76.4434 70.5221Z",
    fill: "#3A1217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4932 43.0788L96.3917 46.6866L91.3212 46.9853L86.4932 43.0788Z",
    fill: "#603135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8821 251.307L77.0244 268.515L81.1792 274.505L80.7406 267.198L83.2037 268.896L82.4636 260.69L77.8821 251.307Z",
    fill: "#B41F2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2944 227.809V233.077L70.849 221.48L64.2944 227.809Z",
    fill: "#B41F2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_556_10751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 780,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDragonLogo);
export default __webpack_public_path__ + "static/media/newDragonLogo.0bc55a20648cd396f3835c3e29f44a72.svg";
export { ForwardRef as ReactComponent };